const areas = [
    { "id": 1, "pid": 0, "name": "省直单位", "type": 1 },
    { "id": 10, "pid": 1, "name": "省纪委监委", "type": 1 },
    { "id": 11, "pid": 1, "name": "省法院", "type": 1 },
    { "id": 12, "pid": 1, "name": "省检察院", "type": 1 },
    { "id": 13, "pid": 1, "name": "省委办公厅", "type": 1 },
    { "id": 14, "pid": 1, "name": "省人大机关", "type": 1 },
    { "id": 15, "pid": 1, "name": "省政府办公厅", "type": 1 },
    { "id": 16, "pid": 1, "name": "省政协机关", "type": 1 },
    { "id": 17, "pid": 1, "name": "省委组织部", "type": 1 },
    { "id": 18, "pid": 1, "name": "省委宣传部", "type": 1 },
    { "id": 19, "pid": 1, "name": "省委统战部", "type": 1 },
    { "id": 20, "pid": 1, "name": "省委政法委", "type": 1 },
    { "id": 21, "pid": 1, "name": "省委政研室", "type": 1 },
    { "id": 22, "pid": 1, "name": "省委网信办", "type": 1 },
    { "id": 23, "pid": 1, "name": "省委外办", "type": 1 },
    { "id": 24, "pid": 1, "name": "省委编办", "type": 1 },
    { "id": 25, "pid": 1, "name": "省委军民融合办", "type": 1 },
    { "id": 26, "pid": 1, "name": "省委台办", "type": 1 },
    { "id": 27, "pid": 1, "name": "省直机关工委", "type": 1 },
    { "id": 28, "pid": 1, "name": "省委老干部局", "type": 1 },
    { "id": 29, "pid": 1, "name": "省发展改革委", "type": 1 },
    { "id": 30, "pid": 1, "name": "经济和信息化厅", "type": 1 },
    { "id": 31, "pid": 1, "name": "教育厅", "type": 1 },
    { "id": 32, "pid": 1, "name": "科技厅", "type": 1 },
    { "id": 33, "pid": 1, "name": "省民族宗教委", "type": 1 },
    { "id": 34, "pid": 1, "name": "公安厅", "type": 1 },
    { "id": 35, "pid": 1, "name": "民政厅", "type": 1 },
    { "id": 36, "pid": 1, "name": "司法厅", "type": 1 },
    { "id": 37, "pid": 1, "name": "财政厅", "type": 1 },
    { "id": 38, "pid": 1, "name": "人社厅", "type": 1 },
    { "id": 39, "pid": 1, "name": "自然资源厅", "type": 1 },
    { "id": 40, "pid": 1, "name": "生态环境厅", "type": 1 },
    { "id": 41, "pid": 1, "name": "住建厅", "type": 1 },
    { "id": 42, "pid": 1, "name": "交通运输厅", "type": 1 },
    { "id": 43, "pid": 1, "name": "水利厅", "type": 1 },
    { "id": 44, "pid": 1, "name": "农业农村厅", "type": 1 },
    { "id": 45, "pid": 1, "name": "商务厅", "type": 1 },
    { "id": 46, "pid": 1, "name": "文旅厅", "type": 1 },
    { "id": 47, "pid": 1, "name": "省卫健委", "type": 1 },
    { "id": 48, "pid": 1, "name": "退役军人事务厅", "type": 1 },
    { "id": 49, "pid": 1, "name": "应急厅", "type": 1 },
    { "id": 50, "pid": 1, "name": "审计厅", "type": 1 },
    { "id": 51, "pid": 1, "name": "省国资委", "type": 1 },
    { "id": 52, "pid": 1, "name": "省市场监管局", "type": 1 },
    { "id": 53, "pid": 1, "name": "省体育局", "type": 1 },
    { "id": 54, "pid": 1, "name": "省统计局", "type": 1 },
    { "id": 55, "pid": 1, "name": "机关事务管理局", "type": 1 },
    { "id": 56, "pid": 1, "name": "省扶贫开发局", "type": 1 },
    { "id": 57, "pid": 1, "name": "省信访局", "type": 1 },
    { "id": 58, "pid": 1, "name": "省人防办", "type": 1 },
    { "id": 59, "pid": 1, "name": "地方金融监管局", "type": 1 },
    { "id": 60, "pid": 1, "name": "省经济合作局", "type": 1 },
    { "id": 61, "pid": 1, "name": "省林业和草原局", "type": 1 },
    { "id": 62, "pid": 1, "name": "省广播电视局", "type": 1 },
    { "id": 63, "pid": 1, "name": "省医疗保障局", "type": 1 },
    { "id": 64, "pid": 1, "name": "省委党史研究室", "type": 1 },
    { "id": 65, "pid": 1, "name": "省委党校", "type": 1 },
    { "id": 66, "pid": 1, "name": "省档案馆", "type": 1 },
    { "id": 67, "pid": 1, "name": "省公务服务中心", "type": 1 },
    { "id": 68, "pid": 1, "name": "省直机关党校", "type": 1 },
    { "id": 69, "pid": 1, "name": "省干函院", "type": 1 },
    { "id": 70, "pid": 1, "name": "省知识产权服务促进中心", "type": 1 },
    { "id": 71, "pid": 1, "name": "省地矿局", "type": 1 },
    { "id": 72, "pid": 1, "name": "省煤田地质局", "type": 1 },
    { "id": 73, "pid": 1, "name": "省核工业地质局", "type": 1 },
    { "id": 74, "pid": 1, "name": "省冶金地勘局", "type": 1 },
    { "id": 75, "pid": 1, "name": "省政务服务和公共资源交易服务中心", "type": 1 },
    { "id": 76, "pid": 1, "name": "省大数据中心", "type": 1 },
    { "id": 77, "pid": 1, "name": "省地方志办", "type": 1 },
    { "id": 78, "pid": 1, "name": "省农科院", "type": 1 },
    { "id": 79, "pid": 1, "name": "省社科院", "type": 1 },
    { "id": 80, "pid": 1, "name": "中测院", "type": 1 },
    { "id": 81, "pid": 1, "name": "省政府参事室", "type": 1 },
    { "id": 82, "pid": 1, "name": "省供销社", "type": 1 },
    { "id": 83, "pid": 1, "name": "省总工会", "type": 1 },
    { "id": 84, "pid": 1, "name": "团省委", "type": 1 },
    { "id": 85, "pid": 1, "name": "省妇联", "type": 1 },
    { "id": 86, "pid": 1, "name": "省文联", "type": 1 },
    { "id": 87, "pid": 1, "name": "省社科联", "type": 1 },
    { "id": 88, "pid": 1, "name": "省作协", "type": 1 },
    { "id": 89, "pid": 1, "name": "省科协", "type": 1 },
    { "id": 90, "pid": 1, "name": "省归国侨联", "type": 1 },
    { "id": 91, "pid": 1, "name": "省残联", "type": 1 },
    { "id": 92, "pid": 1, "name": "省对外友协", "type": 1 },
    { "id": 93, "pid": 1, "name": "省贸促会", "type": 1 },
    { "id": 94, "pid": 1, "name": "省红十字会", "type": 1 },
    { "id": 95, "pid": 1, "name": "省工业合作联社", "type": 1 },
    { "id": 96, "pid": 1, "name": "川报报业集团", "type": 1 },
    { "id": 97, "pid": 1, "name": "四川广播电视台", "type": 1 },
    { "id": 98, "pid": 1, "name": "党建期刊集团", "type": 1 },
    { "id": 99, "pid": 1, "name": "新华发行集团", "type": 1 },
    { "id": 100, "pid": 1, "name": "省文投集团", "type": 1 },
    { "id": 101, "pid": 1, "name": "峨影集团", "type": 1 },
    { "id": 102, "pid": 1, "name": "成都海关", "type": 1 },
    { "id": 103, "pid": 1, "name": "四川税务局", "type": 1 },
    { "id": 104, "pid": 1, "name": "省通信管理局", "type": 1 },
    { "id": 105, "pid": 1, "name": "省邮政管理局", "type": 1 },
    { "id": 106, "pid": 1, "name": "西南民航管理局", "type": 1 },
    { "id": 107, "pid": 1, "name": "成都铁路监管局", "type": 1 },
    { "id": 108, "pid": 1, "name": "省地震局", "type": 1 },
    { "id": 109, "pid": 1, "name": "省气象局", "type": 1 },
    { "id": 110, "pid": 1, "name": "粮食和物资储备局四川局", "type": 1 },
    { "id": 111, "pid": 1, "name": "省烟草专卖局（公司）", "type": 1 },
    { "id": 112, "pid": 1, "name": "四川测绘地理信息局", "type": 1 },
    { "id": 113, "pid": 1, "name": "四川煤矿安全监察局", "type": 1 },
    { "id": 114, "pid": 1, "name": "财政部四川监管局", "type": 1 },
    { "id": 115, "pid": 1, "name": "商务部成特办", "type": 1 },
    { "id": 116, "pid": 1, "name": "国家能源四川监管办", "type": 1 },
    { "id": 117, "pid": 1, "name": "四川调查总队", "type": 1 },
    { "id": 118, "pid": 1, "name": "国家林草局驻成都专员办", "type": 1 },
    { "id": 119, "pid": 1, "name": "生态环保部西南环保督察局", "type": 1 },
    { "id": 120, "pid": 1, "name": "生态环保部西南核与辐射安监站", "type": 1 },
    { "id": 121, "pid": 1, "name": "国家知识产权局审协中心", "type": 1 },
    { "id": 122, "pid": 1, "name": "新华社四川分社", "type": 1 },
    { "id": 123, "pid": 1, "name": "中科院成都分院", "type": 1 },
    { "id": 124, "pid": 1, "name": "大熊猫保护研究中心", "type": 1 },
    { "id": 125, "pid": 1, "name": "农业部沼科所", "type": 1 },
    { "id": 126, "pid": 1, "name": "邮政四川分公司", "type": 1 },
    { "id": 127, "pid": 1, "name": "应急部四川消防研究所", "type": 1 },
    { "id": 128, "pid": 1, "name": "邮储银行四川分行", "type": 1 },
    { "id": 129, "pid": 1, "name": "都市农业研究所", "type": 1 },
    { "id": 130, "pid": 1, "name": "省消防救援总队", "type": 1 },
    { "id": 131, "pid": 1, "name": "西藏成办", "type": 1 },
    { "id": 132, "pid": 1, "name": "市州驻京机构党总支", "type": 1 },
    { "id": 133, "pid": 1, "name": "四川边检总站", "type": 1 },
    { "id": 134, "pid": 1, "name": "中国黄金集团四川公司", "type": 1 },
    { "id": 135, "pid": 1, "name": "四川省社会组织第一综合党委", "type": 1 },
    { "id": 279, "pid": 0, "name": "成都市", "type": 2 },
    { "id": 280, "pid": 0, "name": "自贡市", "type": 2 },
    { "id": 281, "pid": 0, "name": "攀枝花市", "type": 2 },
    { "id": 282, "pid": 0, "name": "泸州市", "type": 2 },
    { "id": 283, "pid": 0, "name": "德阳市", "type": 2 },
    { "id": 284, "pid": 0, "name": "绵阳市", "type": 2 },
    { "id": 285, "pid": 0, "name": "广元市", "type": 2 },
    { "id": 286, "pid": 0, "name": "遂宁市", "type": 2 },
    { "id": 287, "pid": 0, "name": "内江市", "type": 2 },
    { "id": 288, "pid": 0, "name": "乐山市", "type": 2 },
    { "id": 289, "pid": 0, "name": "南充市", "type": 2 },
    { "id": 290, "pid": 0, "name": "眉山市", "type": 2 },
    { "id": 291, "pid": 0, "name": "宜宾市", "type": 2 },
    { "id": 292, "pid": 0, "name": "广安市", "type": 2 },
    { "id": 293, "pid": 0, "name": "达州市", "type": 2 },
    { "id": 294, "pid": 0, "name": "雅安市", "type": 2 },
    { "id": 295, "pid": 0, "name": "巴中市", "type": 2 },
    { "id": 296, "pid": 0, "name": "资阳市", "type": 2 },
    { "id": 297, "pid": 0, "name": "阿坝州", "type": 2 },
    { "id": 298, "pid": 0, "name": "甘孜州", "type": 2 },
    { "id": 299, "pid": 0, "name": "凉山州", "type": 2 },
    { "id": 221, "pid": 0, "name": "四川以外地区", "type": 3 },
    { "id": 2000, "pid": 279, "name": "成都市纪委监委", "type": 2 },
    { "id": 2001, "pid": 279, "name": "成都市法院", "type": 2 },
    { "id": 2002, "pid": 279, "name": "成都市检察院", "type": 2 },
    { "id": 2003, "pid": 279, "name": "成都市委办公厅", "type": 2 },
    { "id": 2004, "pid": 279, "name": "成都市人大常委会", "type": 2 },
    { "id": 2005, "pid": 279, "name": "成都市政府办公厅", "type": 2 },
    { "id": 2006, "pid": 279, "name": "成都市政协办公厅", "type": 2 },
    { "id": 2007, "pid": 279, "name": "成都市委组织部", "type": 2 },
    { "id": 2008, "pid": 279, "name": "成都市委宣传部", "type": 2 },
    { "id": 2009, "pid": 279, "name": "成都市委统战部", "type": 2 },
    { "id": 2010, "pid": 279, "name": "成都市委政法委", "type": 2 },
    { "id": 2011, "pid": 279, "name": "成都市委政研室", "type": 2 },
    { "id": 2012, "pid": 279, "name": "成都市委社治委", "type": 2 },
    { "id": 2013, "pid": 279, "name": "成都市委外事委办", "type": 2 },
    { "id": 2014, "pid": 279, "name": "成都市委编办", "type": 2 },
    { "id": 2015, "pid": 279, "name": "成都市直机关工委", "type": 2 },
    { "id": 2016, "pid": 279, "name": "成都市委老干部局", "type": 2 },
    { "id": 2017, "pid": 279, "name": "成都市委党史研究室", "type": 2 },
    { "id": 2018, "pid": 279, "name": "成都市委党校", "type": 2 },
    { "id": 2019, "pid": 279, "name": "成都市档案馆", "type": 2 },
    { "id": 2020, "pid": 279, "name": "成都市发改委", "type": 2 },
    { "id": 2021, "pid": 279, "name": "成都市经信局", "type": 2 },
    { "id": 2022, "pid": 279, "name": "成都市教育局", "type": 2 },
    { "id": 2023, "pid": 279, "name": "成都市科技局", "type": 2 },
    { "id": 2024, "pid": 279, "name": "成都市民宗局", "type": 2 },
    { "id": 2025, "pid": 279, "name": "成都市公安局", "type": 2 },
    { "id": 2026, "pid": 279, "name": "成都市民政局", "type": 2 },
    { "id": 2027, "pid": 279, "name": "成都市司法局", "type": 2 },
    { "id": 2028, "pid": 279, "name": "成都市财政局", "type": 2 },
    { "id": 2029, "pid": 279, "name": "成都市人社局", "type": 2 },
    { "id": 2030, "pid": 279, "name": "成都市规划和自然资源局", "type": 2 },
    { "id": 2031, "pid": 279, "name": "成都市生态环境局", "type": 2 },
    { "id": 2032, "pid": 279, "name": "成都市住建局", "type": 2 },
    { "id": 2033, "pid": 279, "name": "成都市城管委", "type": 2 },
    { "id": 2034, "pid": 279, "name": "成都市交通运输局", "type": 2 },
    { "id": 2035, "pid": 279, "name": "成都市口岸物流办", "type": 2 },
    { "id": 2036, "pid": 279, "name": "成都市水务局", "type": 2 },
    { "id": 2037, "pid": 279, "name": "成都市农业农村局", "type": 2 },
    { "id": 2038, "pid": 279, "name": "成都市公园城市局", "type": 2 },
    { "id": 2039, "pid": 279, "name": "成都市商务局", "type": 2 },
    { "id": 2040, "pid": 279, "name": "成都市投促局", "type": 2 },
    { "id": 2041, "pid": 279, "name": "成都市文广旅局", "type": 2 },
    { "id": 2042, "pid": 279, "name": "成都市卫健委", "type": 2 },
    { "id": 2043, "pid": 279, "name": "成都市退役军人局", "type": 2 },
    { "id": 2044, "pid": 279, "name": "成都市应急局", "type": 2 },
    { "id": 2045, "pid": 279, "name": "成都市审计局", "type": 2 },
    { "id": 2046, "pid": 279, "name": "成都市国资委", "type": 2 },
    { "id": 2047, "pid": 279, "name": "成都市东部新城办", "type": 2 },
    { "id": 2048, "pid": 279, "name": "成都市市场监管局", "type": 2 },
    { "id": 2049, "pid": 279, "name": "成都市体育局", "type": 2 },
    { "id": 2050, "pid": 279, "name": "成都市统计局", "type": 2 },
    { "id": 2051, "pid": 279, "name": "成都市机关事务局", "type": 2 },
    { "id": 2052, "pid": 279, "name": "成都市信访局", "type": 2 },
    { "id": 2053, "pid": 279, "name": "成都市人防办", "type": 2 },
    { "id": 2054, "pid": 279, "name": "成都市金融监管局", "type": 2 },
    { "id": 2055, "pid": 279, "name": "成都市新经济委", "type": 2 },
    { "id": 2056, "pid": 279, "name": "成都市医保局", "type": 2 },
    { "id": 2057, "pid": 279, "name": "成都市政府政研室", "type": 2 },
    { "id": 2058, "pid": 279, "name": "成都市网络理政办", "type": 2 },
    { "id": 2059, "pid": 279, "name": "成都石化园区管委会", "type": 2 },
    { "id": 2060, "pid": 279, "name": "龙泉山城市森林公园管委会", "type": 2 },
    { "id": 2061, "pid": 279, "name": "成都市地志办", "type": 2 },
    { "id": 2062, "pid": 279, "name": "成都市政府火车站管委会", "type": 2 },
    { "id": 2063, "pid": 279, "name": "成都市总工会", "type": 2 },
    { "id": 2064, "pid": 279, "name": "成都团市委", "type": 2 },
    { "id": 2065, "pid": 279, "name": "成都市妇联", "type": 2 },
    { "id": 2066, "pid": 279, "name": "成都市文联", "type": 2 },
    { "id": 2067, "pid": 279, "name": "成都市科协", "type": 2 },
    { "id": 2068, "pid": 279, "name": "成都市社科联（ 院）", "type": 2 },
    { "id": 2069, "pid": 279, "name": "成都市侨联", "type": 2 },
    { "id": 2070, "pid": 279, "name": "成都市贸促会（博览局）", "type": 2 },
    { "id": 2071, "pid": 279, "name": "成都市残联", "type": 2 },
    { "id": 2072, "pid": 279, "name": "成都市红十字会", "type": 2 },
    { "id": 2073, "pid": 279, "name": "成都公积金中心", "type": 2 },
    { "id": 2074, "pid": 279, "name": "成都市公资交易中心", "type": 2 },
    { "id": 2075, "pid": 279, "name": "成都市农林科学院", "type": 2 },
    { "id": 2076, "pid": 279, "name": "国家税务总局成都市税务局", "type": 2 },
    { "id": 2077, "pid": 279, "name": "成都市国安局", "type": 2 },
    { "id": 2078, "pid": 279, "name": "成都市气象局", "type": 2 },
    { "id": 2079, "pid": 279, "name": "成调队", "type": 2 },
    { "id": 2080, "pid": 279, "name": "成都市邮政管理局", "type": 2 },
    { "id": 2081, "pid": 279, "name": "成都市烟草专卖局", "type": 2 },
    { "id": 2082, "pid": 279, "name": "大熊猫国家公园成都管理分局", "type": 2 },
    { "id": 2083, "pid": 279, "name": "成都大运会执委会", "type": 2 },
    { "id": 2084, "pid": 279, "name": "其他", "type": 2 },
    { "id": 2085, "pid": 280, "name": "自贡市委办", "type": 2 },
    { "id": 2086, "pid": 280, "name": "自贡市人大办", "type": 2 },
    { "id": 2087, "pid": 280, "name": "自贡市政府办", "type": 2 },
    { "id": 2088, "pid": 280, "name": "自贡市政协", "type": 2 },
    { "id": 2089, "pid": 280, "name": "自贡市纪委监委", "type": 2 },
    { "id": 2090, "pid": 280, "name": "自贡市中级人民法院", "type": 2 },
    { "id": 2091, "pid": 280, "name": "自贡市检察院", "type": 2 },
    { "id": 2092, "pid": 280, "name": "自贡市委组织部", "type": 2 },
    { "id": 2093, "pid": 280, "name": "自贡市委宣传部", "type": 2 },
    { "id": 2094, "pid": 280, "name": "自贡市委统战部", "type": 2 },
    { "id": 2095, "pid": 280, "name": "自贡市委党校", "type": 2 },
    { "id": 2096, "pid": 280, "name": "自贡日报社", "type": 2 },
    { "id": 2097, "pid": 280, "name": "自贡市发展改革委", "type": 2 },
    { "id": 2098, "pid": 280, "name": "自贡市经济和信息化局", "type": 2 },
    { "id": 2099, "pid": 280, "name": "自贡市科技局", "type": 2 },
    { "id": 2100, "pid": 280, "name": "自贡市民政局", "type": 2 },
    { "id": 2101, "pid": 280, "name": "自贡市财政局", "type": 2 },
    { "id": 2102, "pid": 280, "name": "自贡市人力资源社会保障局", "type": 2 },
    { "id": 2103, "pid": 280, "name": "自贡市城乡建设住房保障局", "type": 2 },
    { "id": 2104, "pid": 280, "name": "自贡市交通局", "type": 2 },
    { "id": 2105, "pid": 280, "name": "自贡市水务局", "type": 2 },
    { "id": 2106, "pid": 280, "name": "自贡市农业农村局", "type": 2 },
    { "id": 2107, "pid": 280, "name": "自贡市商务局", "type": 2 },
    { "id": 2108, "pid": 280, "name": "自贡市文化广播电视和旅游局", "type": 2 },
    { "id": 2109, "pid": 280, "name": "自贡市生态环境局", "type": 2 },
    { "id": 2110, "pid": 280, "name": "自贡市统计局", "type": 2 },
    { "id": 2111, "pid": 280, "name": "自贡市城市管理行政执法局", "type": 2 },
    { "id": 2112, "pid": 280, "name": "自贡市国资委", "type": 2 },
    { "id": 2113, "pid": 280, "name": "自贡市投资促进局", "type": 2 },
    { "id": 2114, "pid": 280, "name": "自贡市政务服务和数字化管理局", "type": 2 },
    { "id": 2115, "pid": 280, "name": "自贡市税务局", "type": 2 },
    { "id": 2116, "pid": 280, "name": "自贡市气象局", "type": 2 },
    { "id": 2117, "pid": 280, "name": "自贡市总工会", "type": 2 },
    { "id": 2118, "pid": 280, "name": "自贡市供销社", "type": 2 },
    { "id": 2119, "pid": 280, "name": "自贡市自然资源和规划局", "type": 2 },
    { "id": 2120, "pid": 280, "name": "自贡市退役军人事务局", "type": 2 },
    { "id": 2121, "pid": 280, "name": "自贡市应急管理局", "type": 2 },
    { "id": 2122, "pid": 280, "name": "自贡市市场监督管理局", "type": 2 },
    { "id": 2123, "pid": 280, "name": "自贡市审计局", "type": 2 },
    { "id": 2124, "pid": 280, "name": "自贡市卫生健康委员会", "type": 2 },
    { "id": 2125, "pid": 280, "name": "自贡市教体局", "type": 2 },
    { "id": 2126, "pid": 280, "name": "自贡市公安局", "type": 2 },
    { "id": 2127, "pid": 280, "name": "自贡市司法局", "type": 2 },
    { "id": 2128, "pid": 280, "name": "自贡市国安局", "type": 2 },
    { "id": 2129, "pid": 280, "name": "自贡市工商联", "type": 2 },
    { "id": 2130, "pid": 280, "name": "自贡市委政策研究室", "type": 2 },
    { "id": 2131, "pid": 280, "name": "自贡市委编办机关", "type": 2 },
    { "id": 2132, "pid": 280, "name": "自贡市人防办机关", "type": 2 },
    { "id": 2133, "pid": 280, "name": "自贡团市委", "type": 2 },
    { "id": 2134, "pid": 280, "name": "自贡市文联", "type": 2 },
    { "id": 2135, "pid": 280, "name": "自贡市档案馆", "type": 2 },
    { "id": 2136, "pid": 280, "name": "自贡市委老干部局", "type": 2 },
    { "id": 2137, "pid": 280, "name": "自贡市机关事务管理局", "type": 2 },
    { "id": 2138, "pid": 280, "name": "自贡市信访局", "type": 2 },
    { "id": 2139, "pid": 280, "name": "自贡市金融工作局", "type": 2 },
    { "id": 2140, "pid": 280, "name": "自贡市医疗保障局", "type": 2 },
    { "id": 2141, "pid": 280, "name": "自贡市委保密机要局", "type": 2 },
    { "id": 2142, "pid": 280, "name": "自贡市委目标绩效管理办公室", "type": 2 },
    { "id": 2143, "pid": 280, "name": "自贡市委政法委", "type": 2 },
    { "id": 2144, "pid": 280, "name": "自贡市直机关工委", "type": 2 },
    { "id": 2145, "pid": 280, "name": "自贡市口岸与物流办公室", "type": 2 },
    { "id": 2146, "pid": 280, "name": "自贡市公务服务中心", "type": 2 },
    { "id": 2147, "pid": 280, "name": "自贡市公积金中心", "type": 2 },
    { "id": 2148, "pid": 280, "name": "自贡市科协", "type": 2 },
    { "id": 2149, "pid": 280, "name": "自贡市妇联", "type": 2 },
    { "id": 2150, "pid": 280, "name": "自贡市残联", "type": 2 },
    { "id": 2151, "pid": 280, "name": "自贡市邮政管理局", "type": 2 },
    { "id": 2152, "pid": 280, "name": "国家统计局自贡调查队", "type": 2 },
    { "id": 2153, "pid": 280, "name": "自贡市地方志办公室", "type": 2 },
    { "id": 2154, "pid": 280, "name": "自贡市东部新城建设发展中心", "type": 2 },
    { "id": 2155, "pid": 280, "name": "自贡市红十字会", "type": 2 },
    { "id": 2156, "pid": 280, "name": "其他", "type": 2 },
    { "id": 2157, "pid": 281, "name": "攀枝花市纪委监委机关", "type": 2 },
    { "id": 2158, "pid": 281, "name": "攀枝花市法院", "type": 2 },
    { "id": 2159, "pid": 281, "name": "攀枝花市检察院", "type": 2 },
    { "id": 2160, "pid": 281, "name": "攀枝花市委办公室", "type": 2 },
    { "id": 2161, "pid": 281, "name": "攀枝花市人大常委会办公室", "type": 2 },
    { "id": 2162, "pid": 281, "name": "攀枝花市政府办公室", "type": 2 },
    { "id": 2163, "pid": 281, "name": "攀枝花市政协办公室", "type": 2 },
    { "id": 2164, "pid": 281, "name": "攀枝花市委组织部", "type": 2 },
    { "id": 2165, "pid": 281, "name": "攀枝花市委宣传部", "type": 2 },
    { "id": 2166, "pid": 281, "name": "攀枝花市委统战部", "type": 2 },
    { "id": 2167, "pid": 281, "name": "攀枝花市委政法委", "type": 2 },
    { "id": 2168, "pid": 281, "name": "攀枝花市委编办", "type": 2 },
    { "id": 2169, "pid": 281, "name": "攀枝花市直机关工委", "type": 2 },
    { "id": 2170, "pid": 281, "name": "攀枝花市发展改革委", "type": 2 },
    { "id": 2171, "pid": 281, "name": "攀枝花市经济和信息化局", "type": 2 },
    { "id": 2172, "pid": 281, "name": "攀枝花市教育和体育局", "type": 2 },
    { "id": 2173, "pid": 281, "name": "攀枝花市科技局", "type": 2 },
    { "id": 2174, "pid": 281, "name": "攀枝花市公安局", "type": 2 },
    { "id": 2175, "pid": 281, "name": "攀枝花市民政局", "type": 2 },
    { "id": 2176, "pid": 281, "name": "攀枝花市司法局", "type": 2 },
    { "id": 2177, "pid": 281, "name": "攀枝花市财政局", "type": 2 },
    { "id": 2178, "pid": 281, "name": "攀枝花市人力资源社会保障局", "type": 2 },
    { "id": 2179, "pid": 281, "name": "攀枝花市自然资源和规划局", "type": 2 },
    { "id": 2180, "pid": 281, "name": "攀枝花市生态环境局", "type": 2 },
    { "id": 2181, "pid": 281, "name": "攀枝花市住房城乡建设局", "type": 2 },
    { "id": 2182, "pid": 281, "name": "攀枝花市交通运输局", "type": 2 },
    { "id": 2183, "pid": 281, "name": "攀枝花市水利局", "type": 2 },
    { "id": 2184, "pid": 281, "name": "攀枝花市农业农村局", "type": 2 },
    { "id": 2185, "pid": 281, "name": "攀枝花市商务局", "type": 2 },
    { "id": 2186, "pid": 281, "name": "攀枝花市文化广播电视和旅游局", "type": 2 },
    { "id": 2187, "pid": 281, "name": "攀枝花市卫生健康委", "type": 2 },
    { "id": 2188, "pid": 281, "name": "攀枝花市退役军人事务局", "type": 2 },
    { "id": 2189, "pid": 281, "name": "攀枝花市应急管理局", "type": 2 },
    { "id": 2190, "pid": 281, "name": "攀枝花市审计局", "type": 2 },
    { "id": 2191, "pid": 281, "name": "攀枝花市城管执法局", "type": 2 },
    { "id": 2192, "pid": 281, "name": "攀枝花市国资委", "type": 2 },
    { "id": 2193, "pid": 281, "name": "攀枝花市市场监督管理局", "type": 2 },
    { "id": 2194, "pid": 281, "name": "攀枝花市统计局", "type": 2 },
    { "id": 2195, "pid": 281, "name": "攀枝花市扶贫开发局", "type": 2 },
    { "id": 2196, "pid": 281, "name": "攀枝花市信访局", "type": 2 },
    { "id": 2197, "pid": 281, "name": "攀枝花市人防办", "type": 2 },
    { "id": 2198, "pid": 281, "name": "攀枝花市金融工作局", "type": 2 },
    { "id": 2199, "pid": 281, "name": "攀枝花市经济合作局", "type": 2 },
    { "id": 2200, "pid": 281, "name": "攀枝花市林业局", "type": 2 },
    { "id": 2201, "pid": 281, "name": "攀枝花市医保局", "type": 2 },
    { "id": 2202, "pid": 281, "name": "攀枝花市政务管理局", "type": 2 },
    { "id": 2203, "pid": 281, "name": "攀枝花市税务局", "type": 2 },
    { "id": 2204, "pid": 281, "name": "攀枝花市邮政管理局", "type": 2 },
    { "id": 2205, "pid": 281, "name": "攀枝花市气象局", "type": 2 },
    { "id": 2206, "pid": 281, "name": "攀枝花国调队", "type": 2 },
    { "id": 2207, "pid": 281, "name": "攀枝花市委党校", "type": 2 },
    { "id": 2208, "pid": 281, "name": "攀枝花市委党史研究室", "type": 2 },
    { "id": 2209, "pid": 281, "name": "攀枝花日报社", "type": 2 },
    { "id": 2210, "pid": 281, "name": "攀枝花市档案馆", "type": 2 },
    { "id": 2211, "pid": 281, "name": "攀枝花市机关事务服务中心", "type": 2 },
    { "id": 2212, "pid": 281, "name": "攀枝花市供销社", "type": 2 },
    { "id": 2213, "pid": 281, "name": "攀枝花市公积金中心", "type": 2 },
    { "id": 2214, "pid": 281, "name": "攀枝花市农林科学院", "type": 2 },
    { "id": 2215, "pid": 281, "name": "攀枝花市地方志办", "type": 2 },
    { "id": 2216, "pid": 281, "name": "攀枝花市总工会", "type": 2 },
    { "id": 2217, "pid": 281, "name": "攀枝花团市委", "type": 2 },
    { "id": 2218, "pid": 281, "name": "攀枝花市妇联", "type": 2 },
    { "id": 2219, "pid": 281, "name": "攀枝花市文联", "type": 2 },
    { "id": 2220, "pid": 281, "name": "攀枝花市社科联", "type": 2 },
    { "id": 2221, "pid": 281, "name": "攀枝花市科协", "type": 2 },
    { "id": 2222, "pid": 281, "name": "攀枝花市残联", "type": 2 },
    { "id": 2223, "pid": 281, "name": "四川银行", "type": 2 },
    { "id": 2224, "pid": 281, "name": "其他", "type": 2 },
    { "id": 2225, "pid": 282, "name": "泸州市纪委监委机关", "type": 2 },
    { "id": 2226, "pid": 282, "name": "泸州市中级法院", "type": 2 },
    { "id": 2227, "pid": 282, "name": "泸州市检察院", "type": 2 },
    { "id": 2228, "pid": 282, "name": "泸州市委办公室", "type": 2 },
    { "id": 2229, "pid": 282, "name": "泸州市人大常委会办公室", "type": 2 },
    { "id": 2230, "pid": 282, "name": "泸州市政府办公室", "type": 2 },
    { "id": 2231, "pid": 282, "name": "泸州市政协办公室", "type": 2 },
    { "id": 2232, "pid": 282, "name": "泸州市委组织部", "type": 2 },
    { "id": 2233, "pid": 282, "name": "泸州市委宣传部", "type": 2 },
    { "id": 2234, "pid": 282, "name": "泸州市委统战部", "type": 2 },
    { "id": 2235, "pid": 282, "name": "泸州市委政法委", "type": 2 },
    { "id": 2236, "pid": 282, "name": "泸州市委政研室", "type": 2 },
    { "id": 2237, "pid": 282, "name": "泸州市委编办", "type": 2 },
    { "id": 2238, "pid": 282, "name": "泸州市直机关工委", "type": 2 },
    { "id": 2239, "pid": 282, "name": "泸州市委老干部局", "type": 2 },
    { "id": 2240, "pid": 282, "name": "泸州市委保密机要局", "type": 2 },
    { "id": 2241, "pid": 282, "name": "泸州市委目标绩效办", "type": 2 },
    { "id": 2242, "pid": 282, "name": "泸州市委党校", "type": 2 },
    { "id": 2243, "pid": 282, "name": "泸州市发展改革委", "type": 2 },
    { "id": 2244, "pid": 282, "name": "泸州市教育体育局", "type": 2 },
    { "id": 2245, "pid": 282, "name": "泸州市经济和信息化局", "type": 2 },
    { "id": 2246, "pid": 282, "name": "泸州市科技和人才局", "type": 2 },
    { "id": 2247, "pid": 282, "name": "泸州市民政局", "type": 2 },
    { "id": 2248, "pid": 282, "name": "泸州市财政局", "type": 2 },
    { "id": 2249, "pid": 282, "name": "泸州市公安局", "type": 2 },
    { "id": 2250, "pid": 282, "name": "泸州市司法局", "type": 2 },
    { "id": 2251, "pid": 282, "name": "泸州市人力资源社会保障局", "type": 2 },
    { "id": 2252, "pid": 282, "name": "泸州市生态环境局", "type": 2 },
    { "id": 2253, "pid": 282, "name": "泸州市交通运输局", "type": 2 },
    { "id": 2254, "pid": 282, "name": "泸州市农业农村局", "type": 2 },
    { "id": 2255, "pid": 282, "name": "泸州市自然资源和规划局", "type": 2 },
    { "id": 2256, "pid": 282, "name": "泸州市住房城乡建设局", "type": 2 },
    { "id": 2257, "pid": 282, "name": "泸州市水务局", "type": 2 },
    { "id": 2258, "pid": 282, "name": "泸州市商务会展局", "type": 2 },
    { "id": 2259, "pid": 282, "name": "泸州市卫生健康委", "type": 2 },
    { "id": 2260, "pid": 282, "name": "泸州市文化广电旅游局", "type": 2 },
    { "id": 2261, "pid": 282, "name": "泸州市退役军人局", "type": 2 },
    { "id": 2262, "pid": 282, "name": "泸州市审计局", "type": 2 },
    { "id": 2263, "pid": 282, "name": "泸州市应急局", "type": 2 },
    { "id": 2264, "pid": 282, "name": "泸州市城管执法局", "type": 2 },
    { "id": 2265, "pid": 282, "name": "泸州市国资委", "type": 2 },
    { "id": 2266, "pid": 282, "name": "泸州市统计局", "type": 2 },
    { "id": 2267, "pid": 282, "name": "泸州市市场监管局", "type": 2 },
    { "id": 2268, "pid": 282, "name": "泸州市扶贫开发局", "type": 2 },
    { "id": 2269, "pid": 282, "name": "泸州市金融工作局", "type": 2 },
    { "id": 2270, "pid": 282, "name": "泸州市林业竹业局", "type": 2 },
    { "id": 2271, "pid": 282, "name": "泸州市酒业发展局", "type": 2 },
    { "id": 2272, "pid": 282, "name": "泸州市信访局", "type": 2 },
    { "id": 2273, "pid": 282, "name": "泸州市经济合作外事局", "type": 2 },
    { "id": 2274, "pid": 282, "name": "泸州市医保局", "type": 2 },
    { "id": 2275, "pid": 282, "name": "泸州市政务服务和非公经济发展局", "type": 2 },
    { "id": 2276, "pid": 282, "name": "泸州市数字经济发展局", "type": 2 },
    { "id": 2277, "pid": 282, "name": "泸州市公路局", "type": 2 },
    { "id": 2278, "pid": 282, "name": "泸州市供销社", "type": 2 },
    { "id": 2279, "pid": 282, "name": "泸州国安局", "type": 2 },
    { "id": 2280, "pid": 282, "name": "泸州市口岸物流办", "type": 2 },
    { "id": 2281, "pid": 282, "name": "泸州市人防办", "type": 2 },
    { "id": 2282, "pid": 282, "name": "泸州市税务局", "type": 2 },
    { "id": 2283, "pid": 282, "name": "泸州市气象局", "type": 2 },
    { "id": 2284, "pid": 282, "name": "泸州市总工会", "type": 2 },
    { "id": 2285, "pid": 282, "name": "泸州团市委", "type": 2 },
    { "id": 2286, "pid": 282, "name": "泸州市妇联", "type": 2 },
    { "id": 2287, "pid": 282, "name": "泸州市残联", "type": 2 },
    { "id": 2288, "pid": 282, "name": "泸州调查队", "type": 2 },
    { "id": 2289, "pid": 282, "name": "泸州市科协", "type": 2 },
    { "id": 2290, "pid": 282, "name": "泸州日报社", "type": 2 },
    { "id": 2291, "pid": 282, "name": "泸州市邮政管理局", "type": 2 },
    { "id": 2292, "pid": 282, "name": "泸州市社科联", "type": 2 },
    { "id": 2293, "pid": 282, "name": "泸州市文联", "type": 2 },
    { "id": 2294, "pid": 282, "name": "泸州市红十字会", "type": 2 },
    { "id": 2295, "pid": 282, "name": "其他", "type": 2 },
    { "id": 2296, "pid": 283, "name": "德阳市流动人才", "type": 2 },
    { "id": 2297, "pid": 283, "name": "德阳市个私协会", "type": 2 },
    { "id": 2298, "pid": 283, "name": "德阳市纪委", "type": 2 },
    { "id": 2299, "pid": 283, "name": "德阳市中级法院", "type": 2 },
    { "id": 2300, "pid": 283, "name": "德阳市检察院", "type": 2 },
    { "id": 2301, "pid": 283, "name": "德阳市委办", "type": 2 },
    { "id": 2302, "pid": 283, "name": "德阳市人大常委会", "type": 2 },
    { "id": 2303, "pid": 283, "name": "德阳市政府办", "type": 2 },
    { "id": 2304, "pid": 283, "name": "德阳市政协", "type": 2 },
    { "id": 2305, "pid": 283, "name": "德阳市委组织部", "type": 2 },
    { "id": 2306, "pid": 283, "name": "德阳市委宣传部", "type": 2 },
    { "id": 2307, "pid": 283, "name": "德阳市委统战部", "type": 2 },
    { "id": 2308, "pid": 283, "name": "德阳市委党校", "type": 2 },
    { "id": 2309, "pid": 283, "name": "德阳市发改委", "type": 2 },
    { "id": 2310, "pid": 283, "name": "德阳市经信局", "type": 2 },
    { "id": 2311, "pid": 283, "name": "德阳市教育局", "type": 2 },
    { "id": 2312, "pid": 283, "name": "德阳市科技局", "type": 2 },
    { "id": 2313, "pid": 283, "name": "德阳市公安局", "type": 2 },
    { "id": 2314, "pid": 283, "name": "德阳市民政局", "type": 2 },
    { "id": 2315, "pid": 283, "name": "德阳市司法局", "type": 2 },
    { "id": 2316, "pid": 283, "name": "德阳市财政局", "type": 2 },
    { "id": 2317, "pid": 283, "name": "德阳市人社局", "type": 2 },
    { "id": 2318, "pid": 283, "name": "德阳市自然资源局", "type": 2 },
    { "id": 2319, "pid": 283, "name": "德阳市生态环境局", "type": 2 },
    { "id": 2320, "pid": 283, "name": "德阳市住建局", "type": 2 },
    { "id": 2321, "pid": 283, "name": "德阳市城管执法局", "type": 2 },
    { "id": 2322, "pid": 283, "name": "德阳市交通局", "type": 2 },
    { "id": 2323, "pid": 283, "name": "德阳市水利局", "type": 2 },
    { "id": 2324, "pid": 283, "name": "德阳市农业农村局", "type": 2 },
    { "id": 2325, "pid": 283, "name": "德阳市商务局", "type": 2 },
    { "id": 2326, "pid": 283, "name": "德阳市文旅局", "type": 2 },
    { "id": 2327, "pid": 283, "name": "德阳市卫健委", "type": 2 },
    { "id": 2328, "pid": 283, "name": "德阳市退役军人局", "type": 2 },
    { "id": 2329, "pid": 283, "name": "德阳市应急局", "type": 2 },
    { "id": 2330, "pid": 283, "name": "德阳市审计局", "type": 2 },
    { "id": 2331, "pid": 283, "name": "德阳市国资委", "type": 2 },
    { "id": 2332, "pid": 283, "name": "德阳市市场监管局", "type": 2 },
    { "id": 2333, "pid": 283, "name": "德阳市体育局", "type": 2 },
    { "id": 2334, "pid": 283, "name": "德阳市统计局", "type": 2 },
    { "id": 2335, "pid": 283, "name": "德阳市政务和大数据局", "type": 2 },
    { "id": 2336, "pid": 283, "name": "德阳市经外局（市供销社）", "type": 2 },
    { "id": 2337, "pid": 283, "name": "德阳市公积金中心", "type": 2 },
    { "id": 2338, "pid": 283, "name": "德阳日报社", "type": 2 },
    { "id": 2339, "pid": 283, "name": "德阳市广播电视台", "type": 2 },
    { "id": 2340, "pid": 283, "name": "德阳市税务局", "type": 2 },
    { "id": 2341, "pid": 283, "name": "德阳国安局", "type": 2 },
    { "id": 2342, "pid": 283, "name": "德阳市气象局", "type": 2 },
    { "id": 2343, "pid": 283, "name": "德阳市烟草专卖局", "type": 2 },
    { "id": 2344, "pid": 283, "name": "德阳市委政法委", "type": 2 },
    { "id": 2345, "pid": 283, "name": "德阳市总工会", "type": 2 },
    { "id": 2346, "pid": 283, "name": "德阳市科协", "type": 2 },
    { "id": 2347, "pid": 283, "name": "德阳市委编办", "type": 2 },
    { "id": 2348, "pid": 283, "name": "德阳市直机关工委", "type": 2 },
    { "id": 2349, "pid": 283, "name": "德阳市委老干局", "type": 2 },
    { "id": 2350, "pid": 283, "name": "德阳市委党史研究室", "type": 2 },
    { "id": 2351, "pid": 283, "name": "德阳市机关事务局", "type": 2 },
    { "id": 2352, "pid": 283, "name": "德阳市扶贫局", "type": 2 },
    { "id": 2353, "pid": 283, "name": "德阳市信访局", "type": 2 },
    { "id": 2354, "pid": 283, "name": "德阳市金融局", "type": 2 },
    { "id": 2355, "pid": 283, "name": "德阳市医保局", "type": 2 },
    { "id": 2356, "pid": 283, "name": "德阳市协同发展局", "type": 2 },
    { "id": 2357, "pid": 283, "name": "德阳团市委", "type": 2 },
    { "id": 2358, "pid": 283, "name": "德阳市妇联", "type": 2 },
    { "id": 2359, "pid": 283, "name": "德阳市残联", "type": 2 },
    { "id": 2360, "pid": 283, "name": "德阳市工商联", "type": 2 },
    { "id": 2361, "pid": 283, "name": "德阳调查队", "type": 2 },
    { "id": 2362, "pid": 283, "name": "德阳计算机学校", "type": 2 },
    { "id": 2363, "pid": 283, "name": "省冶干所", "type": 2 },
    { "id": 2364, "pid": 283, "name": "其他", "type": 2 },
    { "id": 2365, "pid": 284, "name": "绵阳市纪委监委机关", "type": 2 },
    { "id": 2366, "pid": 284, "name": "绵阳市中级法院", "type": 2 },
    { "id": 2367, "pid": 284, "name": "绵阳市检察院", "type": 2 },
    { "id": 2368, "pid": 284, "name": "绵阳市委办公室", "type": 2 },
    { "id": 2369, "pid": 284, "name": "绵阳市人大机关", "type": 2 },
    { "id": 2370, "pid": 284, "name": "绵阳市政府办公室", "type": 2 },
    { "id": 2371, "pid": 284, "name": "绵阳市政协机关", "type": 2 },
    { "id": 2372, "pid": 284, "name": "绵阳市委组织部", "type": 2 },
    { "id": 2373, "pid": 284, "name": "绵阳市委宣传部", "type": 2 },
    { "id": 2374, "pid": 284, "name": "绵阳市委统战部", "type": 2 },
    { "id": 2375, "pid": 284, "name": "绵阳市委政法委", "type": 2 },
    { "id": 2376, "pid": 284, "name": "绵阳市委政研室", "type": 2 },
    { "id": 2377, "pid": 284, "name": "绵阳市委网信办", "type": 2 },
    { "id": 2378, "pid": 284, "name": "绵阳市委外事办", "type": 2 },
    { "id": 2379, "pid": 284, "name": "绵阳市委编办", "type": 2 },
    { "id": 2380, "pid": 284, "name": "绵阳市委军民融合办", "type": 2 },
    { "id": 2381, "pid": 284, "name": "绵阳市直机关工委", "type": 2 },
    { "id": 2382, "pid": 284, "name": "绵阳市委巡察办", "type": 2 },
    { "id": 2383, "pid": 284, "name": "绵阳市委老干部局", "type": 2 },
    { "id": 2384, "pid": 284, "name": "绵阳市委目标绩效管理办", "type": 2 },
    { "id": 2385, "pid": 284, "name": "绵阳市发展和改革委", "type": 2 },
    { "id": 2386, "pid": 284, "name": "绵阳市经济和信息化局", "type": 2 },
    { "id": 2387, "pid": 284, "name": "绵阳市教育和体育局", "type": 2 },
    { "id": 2388, "pid": 284, "name": "绵阳市科学技术局", "type": 2 },
    { "id": 2389, "pid": 284, "name": "绵阳市公安局", "type": 2 },
    { "id": 2390, "pid": 284, "name": "绵阳市民政局", "type": 2 },
    { "id": 2391, "pid": 284, "name": "绵阳市司法局", "type": 2 },
    { "id": 2392, "pid": 284, "name": "绵阳市财政局", "type": 2 },
    { "id": 2393, "pid": 284, "name": "绵阳市人社局", "type": 2 },
    { "id": 2394, "pid": 284, "name": "绵阳市自然资源和规划局", "type": 2 },
    { "id": 2395, "pid": 284, "name": "绵阳市生态环境局", "type": 2 },
    { "id": 2396, "pid": 284, "name": "绵阳市住房和城乡建设委", "type": 2 },
    { "id": 2397, "pid": 284, "name": "绵阳市交通运输局", "type": 2 },
    { "id": 2398, "pid": 284, "name": "绵阳市水利局", "type": 2 },
    { "id": 2399, "pid": 284, "name": "绵阳市农业农村局", "type": 2 },
    { "id": 2400, "pid": 284, "name": "绵阳市商务局", "type": 2 },
    { "id": 2401, "pid": 284, "name": "绵阳市文化广播电视和旅游局", "type": 2 },
    { "id": 2402, "pid": 284, "name": "绵阳市卫生健康委", "type": 2 },
    { "id": 2403, "pid": 284, "name": "绵阳市退役军人事务局", "type": 2 },
    { "id": 2404, "pid": 284, "name": "绵阳市应急管理局", "type": 2 },
    { "id": 2405, "pid": 284, "name": "绵阳市审计局", "type": 2 },
    { "id": 2406, "pid": 284, "name": "绵阳市国有资产监督管理委", "type": 2 },
    { "id": 2407, "pid": 284, "name": "绵阳市市场监督管理局", "type": 2 },
    { "id": 2408, "pid": 284, "name": "绵阳市统计局", "type": 2 },
    { "id": 2409, "pid": 284, "name": "绵阳市扶贫开发局", "type": 2 },
    { "id": 2410, "pid": 284, "name": "绵阳市信访局", "type": 2 },
    { "id": 2411, "pid": 284, "name": "绵阳市金融工作局", "type": 2 },
    { "id": 2412, "pid": 284, "name": "绵阳市经济合作局", "type": 2 },
    { "id": 2413, "pid": 284, "name": "绵阳市林业局", "type": 2 },
    { "id": 2414, "pid": 284, "name": "绵阳市医疗保障局", "type": 2 },
    { "id": 2415, "pid": 284, "name": "绵阳市政务服务监督管理局", "type": 2 },
    { "id": 2416, "pid": 284, "name": "绵阳市机关事务管理局", "type": 2 },
    { "id": 2417, "pid": 284, "name": "绵阳市人民防空办", "type": 2 },
    { "id": 2418, "pid": 284, "name": "绵阳市委党史研究室", "type": 2 },
    { "id": 2419, "pid": 284, "name": "绵阳市委党校", "type": 2 },
    { "id": 2420, "pid": 284, "name": "绵阳市档案馆", "type": 2 },
    { "id": 2421, "pid": 284, "name": "绵阳市公务服务中心", "type": 2 },
    { "id": 2422, "pid": 284, "name": "绵阳日报社", "type": 2 },
    { "id": 2423, "pid": 284, "name": "绵阳广播电视台", "type": 2 },
    { "id": 2424, "pid": 284, "name": "绵阳市住房公积金服务中心", "type": 2 },
    { "id": 2425, "pid": 284, "name": "绵阳市供销合作社联合社", "type": 2 },
    { "id": 2426, "pid": 284, "name": "绵阳地震纪念馆管理中心", "type": 2 },
    { "id": 2427, "pid": 284, "name": "绵阳市农业科学研究院", "type": 2 },
    { "id": 2428, "pid": 284, "name": "大熊猫国家公园绵阳管理分局", "type": 2 },
    { "id": 2429, "pid": 284, "name": "“两弹一星”干部学院", "type": 2 },
    { "id": 2430, "pid": 284, "name": "绵阳市总工会", "type": 2 },
    { "id": 2431, "pid": 284, "name": "绵阳团市委", "type": 2 },
    { "id": 2432, "pid": 284, "name": "绵阳市妇联", "type": 2 },
    { "id": 2433, "pid": 284, "name": "绵阳市工商联", "type": 2 },
    { "id": 2434, "pid": 284, "name": "绵阳市科协", "type": 2 },
    { "id": 2435, "pid": 284, "name": "绵阳市文联", "type": 2 },
    { "id": 2436, "pid": 284, "name": "绵阳市社科联", "type": 2 },
    { "id": 2437, "pid": 284, "name": "绵阳市残联", "type": 2 },
    { "id": 2438, "pid": 284, "name": "绵阳市贸促会", "type": 2 },
    { "id": 2439, "pid": 284, "name": "绵阳市红十字会", "type": 2 },
    { "id": 2440, "pid": 284, "name": "绵阳市侨联", "type": 2 },
    { "id": 2441, "pid": 284, "name": "绵阳市税务局", "type": 2 },
    { "id": 2442, "pid": 284, "name": "绵阳市气象局", "type": 2 },
    { "id": 2443, "pid": 284, "name": "绵阳市烟草专卖局", "type": 2 },
    { "id": 2444, "pid": 284, "name": "绵阳调查队", "type": 2 },
    { "id": 2445, "pid": 284, "name": "其他", "type": 2 },
    { "id": 2446, "pid": 285, "name": "广元市纪委监委机关", "type": 2 },
    { "id": 2447, "pid": 285, "name": "广元市法院", "type": 2 },
    { "id": 2448, "pid": 285, "name": "广元市检察院", "type": 2 },
    { "id": 2449, "pid": 285, "name": "广元市委办公室", "type": 2 },
    { "id": 2450, "pid": 285, "name": "广元市人大常委会办公室", "type": 2 },
    { "id": 2451, "pid": 285, "name": "广元市政府办公室", "type": 2 },
    { "id": 2452, "pid": 285, "name": "广元市政协办公室", "type": 2 },
    { "id": 2453, "pid": 285, "name": "广元市委组织部", "type": 2 },
    { "id": 2454, "pid": 285, "name": "广元市委宣传部", "type": 2 },
    { "id": 2455, "pid": 285, "name": "广元市委统战部", "type": 2 },
    { "id": 2456, "pid": 285, "name": "广元市委政法委", "type": 2 },
    { "id": 2457, "pid": 285, "name": "广元市委政研室", "type": 2 },
    { "id": 2458, "pid": 285, "name": "广元市委编办", "type": 2 },
    { "id": 2459, "pid": 285, "name": "广元市直机关工委", "type": 2 },
    { "id": 2460, "pid": 285, "name": "广元市委群工局", "type": 2 },
    { "id": 2461, "pid": 285, "name": "广元市委三江新区办", "type": 2 },
    { "id": 2462, "pid": 285, "name": "广元市委老干部局", "type": 2 },
    { "id": 2463, "pid": 285, "name": "广元市发展改革委", "type": 2 },
    { "id": 2464, "pid": 285, "name": "广元市经济信息化局", "type": 2 },
    { "id": 2465, "pid": 285, "name": "广元市教育局", "type": 2 },
    { "id": 2466, "pid": 285, "name": "广元市科技局", "type": 2 },
    { "id": 2467, "pid": 285, "name": "广元市公安局", "type": 2 },
    { "id": 2468, "pid": 285, "name": "广元市民政局", "type": 2 },
    { "id": 2469, "pid": 285, "name": "广元市司法局", "type": 2 },
    { "id": 2470, "pid": 285, "name": "广元市财政局", "type": 2 },
    { "id": 2471, "pid": 285, "name": "广元市人力资源社会保障局", "type": 2 },
    { "id": 2472, "pid": 285, "name": "广元市自然资源局", "type": 2 },
    { "id": 2473, "pid": 285, "name": "广元市生态环境局", "type": 2 },
    { "id": 2474, "pid": 285, "name": "广元市住房和城乡建设局", "type": 2 },
    { "id": 2475, "pid": 285, "name": "广元市交通运输局", "type": 2 },
    { "id": 2476, "pid": 285, "name": "广元市水利局", "type": 2 },
    { "id": 2477, "pid": 285, "name": "广元市农业农村局", "type": 2 },
    { "id": 2478, "pid": 285, "name": "广元市商务局", "type": 2 },
    { "id": 2479, "pid": 285, "name": "广元市文化广电旅游局", "type": 2 },
    { "id": 2480, "pid": 285, "name": "广元市卫生健康委", "type": 2 },
    { "id": 2481, "pid": 285, "name": "广元市退役军人事务局", "type": 2 },
    { "id": 2482, "pid": 285, "name": "广元市应急管理局", "type": 2 },
    { "id": 2483, "pid": 285, "name": "广元市审计局", "type": 2 },
    { "id": 2484, "pid": 285, "name": "广元市国资委", "type": 2 },
    { "id": 2485, "pid": 285, "name": "广元市市场监管局", "type": 2 },
    { "id": 2486, "pid": 285, "name": "广元市体育局", "type": 2 },
    { "id": 2487, "pid": 285, "name": "广元市统计局", "type": 2 },
    { "id": 2488, "pid": 285, "name": "广元市扶贫开发局", "type": 2 },
    { "id": 2489, "pid": 285, "name": "广元市人防办", "type": 2 },
    { "id": 2490, "pid": 285, "name": "广元市经济合作局", "type": 2 },
    { "id": 2491, "pid": 285, "name": "广元市林业局", "type": 2 },
    { "id": 2492, "pid": 285, "name": "广元市医保局", "type": 2 },
    { "id": 2493, "pid": 285, "name": "广元市城管执法局", "type": 2 },
    { "id": 2494, "pid": 285, "name": "广元市委党校", "type": 2 },
    { "id": 2495, "pid": 285, "name": "广元市委党史研究室", "type": 2 },
    { "id": 2496, "pid": 285, "name": "广元市档案馆", "type": 2 },
    { "id": 2497, "pid": 285, "name": "广元市政务服务和资源交易中心", "type": 2 },
    { "id": 2498, "pid": 285, "name": "广元金融服务中心", "type": 2 },
    { "id": 2499, "pid": 285, "name": "广元市公积金中心", "type": 2 },
    { "id": 2500, "pid": 285, "name": "广元市供销社", "type": 2 },
    { "id": 2501, "pid": 285, "name": "广元市白龙湖管理局", "type": 2 },
    { "id": 2502, "pid": 285, "name": "广元市以工代赈事务中心", "type": 2 },
    { "id": 2503, "pid": 285, "name": "广元市重点项目事务中心", "type": 2 },
    { "id": 2504, "pid": 285, "name": "广元市机关事务服务中心", "type": 2 },
    { "id": 2505, "pid": 285, "name": "广元市总工会", "type": 2 },
    { "id": 2506, "pid": 285, "name": "广元团市委", "type": 2 },
    { "id": 2507, "pid": 285, "name": "广元市妇联", "type": 2 },
    { "id": 2508, "pid": 285, "name": "广元市科协", "type": 2 },
    { "id": 2509, "pid": 285, "name": "广元市残联", "type": 2 },
    { "id": 2510, "pid": 285, "name": "广元市贸促会", "type": 2 },
    { "id": 2511, "pid": 285, "name": "广元市红十字会", "type": 2 },
    { "id": 2512, "pid": 285, "name": "广元市工商联", "type": 2 },
    { "id": 2513, "pid": 285, "name": "广元日报社", "type": 2 },
    { "id": 2514, "pid": 285, "name": "广元市广播电视台", "type": 2 },
    { "id": 2515, "pid": 285, "name": "广元市税务局", "type": 2 },
    { "id": 2516, "pid": 285, "name": "广元国安局", "type": 2 },
    { "id": 2517, "pid": 285, "name": "广元市气象局", "type": 2 },
    { "id": 2518, "pid": 285, "name": "广元国家调查队", "type": 2 },
    { "id": 2519, "pid": 285, "name": "广元市烟草专卖局", "type": 2 },
    { "id": 2520, "pid": 285, "name": "506台", "type": 2 },
    { "id": 2521, "pid": 285, "name": "广元市荣山地区人民检察院", "type": 2 },
    { "id": 2522, "pid": 285, "name": "广元市机场公安分局", "type": 2 },
    { "id": 2523, "pid": 285, "name": "其他", "type": 2 },
    { "id": 2524, "pid": 286, "name": "遂宁市纪委监委机关", "type": 2 },
    { "id": 2525, "pid": 286, "name": "遂宁市法院", "type": 2 },
    { "id": 2526, "pid": 286, "name": "遂宁市检察院", "type": 2 },
    { "id": 2527, "pid": 286, "name": "遂宁市委办公室", "type": 2 },
    { "id": 2528, "pid": 286, "name": "遂宁市人大常委会办公室", "type": 2 },
    { "id": 2529, "pid": 286, "name": "遂宁市政府办公室", "type": 2 },
    { "id": 2530, "pid": 286, "name": "遂宁市政协办公室", "type": 2 },
    { "id": 2531, "pid": 286, "name": "遂宁市委组织部", "type": 2 },
    { "id": 2532, "pid": 286, "name": "遂宁市委宣传部", "type": 2 },
    { "id": 2533, "pid": 286, "name": "遂宁市委统战部（市民族宗教局）", "type": 2 },
    { "id": 2534, "pid": 286, "name": "遂宁市委政法委", "type": 2 },
    { "id": 2535, "pid": 286, "name": "遂宁市委政研室", "type": 2 },
    { "id": 2536, "pid": 286, "name": "遂宁市委编办", "type": 2 },
    { "id": 2537, "pid": 286, "name": "遂宁市直机关工委", "type": 2 },
    { "id": 2538, "pid": 286, "name": "遂宁市委巡察办", "type": 2 },
    { "id": 2539, "pid": 286, "name": "遂宁市委老干部局", "type": 2 },
    { "id": 2540, "pid": 286, "name": "遂宁市委保密机要局", "type": 2 },
    { "id": 2541, "pid": 286, "name": "遂宁市委绩效办", "type": 2 },
    { "id": 2542, "pid": 286, "name": "遂宁市发展改革委", "type": 2 },
    { "id": 2543, "pid": 286, "name": "遂宁市经济和信息化局", "type": 2 },
    { "id": 2544, "pid": 286, "name": "遂宁市教育体育局", "type": 2 },
    { "id": 2545, "pid": 286, "name": "遂宁市科技局", "type": 2 },
    { "id": 2546, "pid": 286, "name": "遂宁市公安局", "type": 2 },
    { "id": 2547, "pid": 286, "name": "遂宁市民政局", "type": 2 },
    { "id": 2548, "pid": 286, "name": "遂宁市司法局", "type": 2 },
    { "id": 2549, "pid": 286, "name": "遂宁市财政局", "type": 2 },
    { "id": 2550, "pid": 286, "name": "遂宁市人力资源社会保障局", "type": 2 },
    { "id": 2551, "pid": 286, "name": "遂宁市自然资源和规划局", "type": 2 },
    { "id": 2552, "pid": 286, "name": "遂宁市生态环境局", "type": 2 },
    { "id": 2553, "pid": 286, "name": "遂宁市住房城乡建设局", "type": 2 },
    { "id": 2554, "pid": 286, "name": "遂宁市交通运输局", "type": 2 },
    { "id": 2555, "pid": 286, "name": "遂宁市水利局", "type": 2 },
    { "id": 2556, "pid": 286, "name": "遂宁市农业农村局", "type": 2 },
    { "id": 2557, "pid": 286, "name": "遂宁市商务局", "type": 2 },
    { "id": 2558, "pid": 286, "name": "遂宁市文化广电旅游局", "type": 2 },
    { "id": 2559, "pid": 286, "name": "遂宁市卫生健康委", "type": 2 },
    { "id": 2560, "pid": 286, "name": "遂宁市退役军人局", "type": 2 },
    { "id": 2561, "pid": 286, "name": "遂宁市应急局", "type": 2 },
    { "id": 2562, "pid": 286, "name": "遂宁市审计局", "type": 2 },
    { "id": 2563, "pid": 286, "name": "遂宁市城管执法局", "type": 2 },
    { "id": 2564, "pid": 286, "name": "遂宁市国资委", "type": 2 },
    { "id": 2565, "pid": 286, "name": "遂宁市市场监管局", "type": 2 },
    { "id": 2566, "pid": 286, "name": "遂宁市统计局", "type": 2 },
    { "id": 2567, "pid": 286, "name": "遂宁市经济合作局", "type": 2 },
    { "id": 2568, "pid": 286, "name": "遂宁市林业局", "type": 2 },
    { "id": 2569, "pid": 286, "name": "遂宁市信访局", "type": 2 },
    { "id": 2570, "pid": 286, "name": "遂宁市扶贫开发局", "type": 2 },
    { "id": 2571, "pid": 286, "name": "遂宁市金融工作局", "type": 2 },
    { "id": 2572, "pid": 286, "name": "遂宁市政务服务和大数据局", "type": 2 },
    { "id": 2573, "pid": 286, "name": "遂宁市机关事务管理局", "type": 2 },
    { "id": 2574, "pid": 286, "name": "遂宁市医保局", "type": 2 },
    { "id": 2575, "pid": 286, "name": "遂宁军分区", "type": 2 },
    { "id": 2576, "pid": 286, "name": "武警遂宁支队", "type": 2 },
    { "id": 2577, "pid": 286, "name": "遂宁预师二团", "type": 2 },
    { "id": 2578, "pid": 286, "name": "民革市委（遂宁）", "type": 2 },
    { "id": 2579, "pid": 286, "name": "民盟市委（遂宁）", "type": 2 },
    { "id": 2580, "pid": 286, "name": "民建市委（遂宁）", "type": 2 },
    { "id": 2581, "pid": 286, "name": "民进市委（遂宁）", "type": 2 },
    { "id": 2582, "pid": 286, "name": "农工党市委（遂宁）", "type": 2 },
    { "id": 2583, "pid": 286, "name": "致公党省委直属遂宁支部", "type": 2 },
    { "id": 2584, "pid": 286, "name": "遂宁市委党研室", "type": 2 },
    { "id": 2585, "pid": 286, "name": "遂宁市委党校（行政学院）", "type": 2 },
    { "id": 2586, "pid": 286, "name": "遂宁市档案馆", "type": 2 },
    { "id": 2587, "pid": 286, "name": "遂宁市公务服务中心", "type": 2 },
    { "id": 2588, "pid": 286, "name": "遂宁市委讲师团", "type": 2 },
    { "id": 2589, "pid": 286, "name": "遂宁市人防办", "type": 2 },
    { "id": 2590, "pid": 286, "name": "遂宁市地方志办", "type": 2 },
    { "id": 2591, "pid": 286, "name": "遂宁市供销社", "type": 2 },
    { "id": 2592, "pid": 286, "name": "遂宁市公积金中心", "type": 2 },
    { "id": 2593, "pid": 286, "name": "遂宁市土地储备中心", "type": 2 },
    { "id": 2594, "pid": 286, "name": "遂宁市农民工服务中心", "type": 2 },
    { "id": 2595, "pid": 286, "name": "遂宁市公共资源交易中心", "type": 2 },
    { "id": 2596, "pid": 286, "name": "遂宁市产业促进中心", "type": 2 },
    { "id": 2597, "pid": 286, "name": "遂宁市驻京联络处", "type": 2 },
    { "id": 2598, "pid": 286, "name": "遂宁市驻蓉办事处", "type": 2 },
    { "id": 2599, "pid": 286, "name": "遂宁市热线中心", "type": 2 },
    { "id": 2600, "pid": 286, "name": "遂宁市总工会", "type": 2 },
    { "id": 2601, "pid": 286, "name": "共青团遂宁市委", "type": 2 },
    { "id": 2602, "pid": 286, "name": "遂宁市妇联", "type": 2 },
    { "id": 2603, "pid": 286, "name": "遂宁市文联", "type": 2 },
    { "id": 2604, "pid": 286, "name": "遂宁市科协", "type": 2 },
    { "id": 2605, "pid": 286, "name": "遂宁市社科联", "type": 2 },
    { "id": 2606, "pid": 286, "name": "遂宁市工商联", "type": 2 },
    { "id": 2607, "pid": 286, "name": "遂宁市残联", "type": 2 },
    { "id": 2608, "pid": 286, "name": "遂宁市侨联（市对外友协）", "type": 2 },
    { "id": 2609, "pid": 286, "name": "遂宁国安局", "type": 2 },
    { "id": 2610, "pid": 286, "name": "遂宁海关", "type": 2 },
    { "id": 2611, "pid": 286, "name": "遂宁市税务局", "type": 2 },
    { "id": 2612, "pid": 286, "name": "遂宁市邮政管理局", "type": 2 },
    { "id": 2613, "pid": 286, "name": "遂宁市气象局", "type": 2 },
    { "id": 2614, "pid": 286, "name": "遂宁市烟草局", "type": 2 },
    { "id": 2615, "pid": 286, "name": "遂宁调查队", "type": 2 },
    { "id": 2616, "pid": 286, "name": "遂宁大英监狱", "type": 2 },
    { "id": 2617, "pid": 286, "name": "遂宁市消防救援支队", "type": 2 },
    { "id": 2618, "pid": 286, "name": "遂宁人行市中心支行", "type": 2 },
    { "id": 2619, "pid": 286, "name": "遂宁银保监分局", "type": 2 },
    { "id": 2620, "pid": 286, "name": "四川职业技术学院", "type": 2 },
    { "id": 2621, "pid": 286, "name": "农发行遂宁分行", "type": 2 },
    { "id": 2622, "pid": 286, "name": "工行遂宁分行", "type": 2 },
    { "id": 2623, "pid": 286, "name": "农行遂宁分行", "type": 2 },
    { "id": 2624, "pid": 286, "name": "中行遂宁分行", "type": 2 },
    { "id": 2625, "pid": 286, "name": "建行遂宁分行", "type": 2 },
    { "id": 2626, "pid": 286, "name": "邮储银行遂宁分行", "type": 2 },
    { "id": 2627, "pid": 286, "name": "四川农信遂宁办事处", "type": 2 },
    { "id": 2628, "pid": 286, "name": "成都农商行遂宁分行", "type": 2 },
    { "id": 2629, "pid": 286, "name": "中国人寿遂宁分公司", "type": 2 },
    { "id": 2630, "pid": 286, "name": "人保财险遂宁分公司", "type": 2 },
    { "id": 2631, "pid": 286, "name": "国网遂宁供电公司", "type": 2 },
    { "id": 2632, "pid": 286, "name": "川中油气矿", "type": 2 },
    { "id": 2633, "pid": 286, "name": "电信遂宁分公司", "type": 2 },
    { "id": 2634, "pid": 286, "name": "联通遂宁分公司", "type": 2 },
    { "id": 2635, "pid": 286, "name": "移动遂宁分公司", "type": 2 },
    { "id": 2636, "pid": 286, "name": "广电网络遂宁分公司", "type": 2 },
    { "id": 2637, "pid": 286, "name": "万通燃气公司", "type": 2 },
    { "id": 2638, "pid": 286, "name": "铁塔遂宁分公司", "type": 2 },
    { "id": 2639, "pid": 286, "name": "通服遂宁市分公司", "type": 2 },
    { "id": 2640, "pid": 286, "name": "遂宁邮政公司", "type": 2 },
    { "id": 2641, "pid": 286, "name": "遂宁明星电力公司", "type": 2 },
    { "id": 2642, "pid": 286, "name": "遂宁市职业技术学校", "type": 2 },
    { "id": 2643, "pid": 286, "name": "遂宁中学", "type": 2 },
    { "id": 2644, "pid": 286, "name": "遂宁一中", "type": 2 },
    { "id": 2645, "pid": 286, "name": "遂宁二中", "type": 2 },
    { "id": 2646, "pid": 286, "name": "遂宁市中心医院", "type": 2 },
    { "id": 2647, "pid": 286, "name": "遂宁市一医院", "type": 2 },
    { "id": 2648, "pid": 286, "name": "遂宁市中医院", "type": 2 },
    { "id": 2649, "pid": 286, "name": "遂宁银行", "type": 2 },
    { "id": 2650, "pid": 286, "name": "遂宁兴业集团", "type": 2 },
    { "id": 2651, "pid": 286, "name": "遂宁发展集团", "type": 2 },
    { "id": 2652, "pid": 286, "name": "遂宁传媒集团", "type": 2 },
    { "id": 2653, "pid": 286, "name": "其他", "type": 2 },
    { "id": 2654, "pid": 287, "name": "内江市纪委监委", "type": 2 },
    { "id": 2655, "pid": 287, "name": "内江市法院", "type": 2 },
    { "id": 2656, "pid": 287, "name": "内江市检察院", "type": 2 },
    { "id": 2657, "pid": 287, "name": "内江市委办公室", "type": 2 },
    { "id": 2658, "pid": 287, "name": "内江市人大常委会办公室", "type": 2 },
    { "id": 2659, "pid": 287, "name": "内江市政府办公室", "type": 2 },
    { "id": 2660, "pid": 287, "name": "内江市政协办公室", "type": 2 },
    { "id": 2661, "pid": 287, "name": "内江市委组织部", "type": 2 },
    { "id": 2662, "pid": 287, "name": "内江市委宣传部", "type": 2 },
    { "id": 2663, "pid": 287, "name": "内江市委统战部", "type": 2 },
    { "id": 2664, "pid": 287, "name": "内江市委政法委", "type": 2 },
    { "id": 2665, "pid": 287, "name": "内江市委政研室", "type": 2 },
    { "id": 2666, "pid": 287, "name": "内江市委网信办", "type": 2 },
    { "id": 2667, "pid": 287, "name": "内江市委编办", "type": 2 },
    { "id": 2668, "pid": 287, "name": "内江市直机关工委", "type": 2 },
    { "id": 2669, "pid": 287, "name": "内江市委巡察办", "type": 2 },
    { "id": 2670, "pid": 287, "name": "内江市委老干部局", "type": 2 },
    { "id": 2671, "pid": 287, "name": "内江市委保密机要局", "type": 2 },
    { "id": 2672, "pid": 287, "name": "内江市委目标绩效办", "type": 2 },
    { "id": 2673, "pid": 287, "name": "内江市发展改革委", "type": 2 },
    { "id": 2674, "pid": 287, "name": "内江市经济和信息化局", "type": 2 },
    { "id": 2675, "pid": 287, "name": "内江市教育局", "type": 2 },
    { "id": 2676, "pid": 287, "name": "内江市科技局", "type": 2 },
    { "id": 2677, "pid": 287, "name": "内江市公安局", "type": 2 },
    { "id": 2678, "pid": 287, "name": "内江市民政局", "type": 2 },
    { "id": 2679, "pid": 287, "name": "内江市司法局", "type": 2 },
    { "id": 2680, "pid": 287, "name": "内江市人力资源社会保障局", "type": 2 },
    { "id": 2681, "pid": 287, "name": "内江市生态环境局", "type": 2 },
    { "id": 2682, "pid": 287, "name": "内江市交通运输局", "type": 2 },
    { "id": 2683, "pid": 287, "name": "内江市财政局", "type": 2 },
    { "id": 2684, "pid": 287, "name": "内江市自然资源规划局", "type": 2 },
    { "id": 2685, "pid": 287, "name": "内江市住房城乡建设局", "type": 2 },
    { "id": 2686, "pid": 287, "name": "内江市水利局", "type": 2 },
    { "id": 2687, "pid": 287, "name": "内江市商务局", "type": 2 },
    { "id": 2688, "pid": 287, "name": "内江市文化广电和旅游局", "type": 2 },
    { "id": 2689, "pid": 287, "name": "内江市农业农村局", "type": 2 },
    { "id": 2690, "pid": 287, "name": "内江市市场监管局", "type": 2 },
    { "id": 2691, "pid": 287, "name": "内江市卫生健康委", "type": 2 },
    { "id": 2692, "pid": 287, "name": "内江市应急局", "type": 2 },
    { "id": 2693, "pid": 287, "name": "内江市城管执法局", "type": 2 },
    { "id": 2694, "pid": 287, "name": "内江市退役军人局", "type": 2 },
    { "id": 2695, "pid": 287, "name": "内江市体育局", "type": 2 },
    { "id": 2696, "pid": 287, "name": "内江市扶贫开发局", "type": 2 },
    { "id": 2697, "pid": 287, "name": "内江市人防办", "type": 2 },
    { "id": 2698, "pid": 287, "name": "内江市医保局", "type": 2 },
    { "id": 2699, "pid": 287, "name": "内江市大数据局", "type": 2 },
    { "id": 2700, "pid": 287, "name": "内江市审计局", "type": 2 },
    { "id": 2701, "pid": 287, "name": "内江市国资委", "type": 2 },
    { "id": 2702, "pid": 287, "name": "内江市统计局", "type": 2 },
    { "id": 2703, "pid": 287, "name": "内江市信访局", "type": 2 },
    { "id": 2704, "pid": 287, "name": "内江市经济合作局", "type": 2 },
    { "id": 2705, "pid": 287, "name": "内江市政务服务局", "type": 2 },
    { "id": 2706, "pid": 287, "name": "内江国际物流港服务中心", "type": 2 },
    { "id": 2707, "pid": 287, "name": "内江市委党史地方志研究室", "type": 2 },
    { "id": 2708, "pid": 287, "name": "内江市档案馆", "type": 2 },
    { "id": 2709, "pid": 287, "name": "内江市公路建设中心", "type": 2 },
    { "id": 2710, "pid": 287, "name": "内江市委党校", "type": 2 },
    { "id": 2711, "pid": 287, "name": "内江市供销社", "type": 2 },
    { "id": 2712, "pid": 287, "name": "内江市公共资源交易中心", "type": 2 },
    { "id": 2713, "pid": 287, "name": "内江市总工会", "type": 2 },
    { "id": 2714, "pid": 287, "name": "内江市妇联", "type": 2 },
    { "id": 2715, "pid": 287, "name": "内江市文联", "type": 2 },
    { "id": 2716, "pid": 287, "name": "内江市红十字会", "type": 2 },
    { "id": 2717, "pid": 287, "name": "内江团市委", "type": 2 },
    { "id": 2718, "pid": 287, "name": "内江市科协", "type": 2 },
    { "id": 2719, "pid": 287, "name": "内江市残联", "type": 2 },
    { "id": 2720, "pid": 287, "name": "内江市工商联", "type": 2 },
    { "id": 2721, "pid": 287, "name": "内江市农科院", "type": 2 },
    { "id": 2722, "pid": 287, "name": "内江市税务局", "type": 2 },
    { "id": 2723, "pid": 287, "name": "内江日报社", "type": 2 },
    { "id": 2724, "pid": 287, "name": "内江国安局", "type": 2 },
    { "id": 2725, "pid": 287, "name": "内江市邮政管理局", "type": 2 },
    { "id": 2726, "pid": 287, "name": "内江市烟草专卖局", "type": 2 },
    { "id": 2727, "pid": 287, "name": "内江市气象局", "type": 2 },
    { "id": 2728, "pid": 287, "name": "国统内江调查队", "type": 2 },
    { "id": 2729, "pid": 287, "name": "内江兴隆村镇银行", "type": 2 },
    { "id": 2730, "pid": 287, "name": "内江广播电视台", "type": 2 },
    { "id": 2731, "pid": 287, "name": "其他", "type": 2 },
    { "id": 2732, "pid": 288, "name": "乐山市委办公室", "type": 2 },
    { "id": 2733, "pid": 288, "name": "乐山市人大常委会", "type": 2 },
    { "id": 2734, "pid": 288, "name": "乐山市政府办公室", "type": 2 },
    { "id": 2735, "pid": 288, "name": "乐山市政协", "type": 2 },
    { "id": 2736, "pid": 288, "name": "乐山市纪委监委", "type": 2 },
    { "id": 2737, "pid": 288, "name": "乐山市法院", "type": 2 },
    { "id": 2738, "pid": 288, "name": "乐山市检察院", "type": 2 },
    { "id": 2739, "pid": 288, "name": "乐山市委组织部", "type": 2 },
    { "id": 2740, "pid": 288, "name": "乐山市委宣传部", "type": 2 },
    { "id": 2741, "pid": 288, "name": "乐山市委统战部", "type": 2 },
    { "id": 2742, "pid": 288, "name": "乐山市委政法委", "type": 2 },
    { "id": 2743, "pid": 288, "name": "乐山市委老干部局", "type": 2 },
    { "id": 2744, "pid": 288, "name": "乐山市委党校", "type": 2 },
    { "id": 2745, "pid": 288, "name": "乐山市发展改革委", "type": 2 },
    { "id": 2746, "pid": 288, "name": "乐山市经济信息化局", "type": 2 },
    { "id": 2747, "pid": 288, "name": "乐山市经济合作外事局", "type": 2 },
    { "id": 2748, "pid": 288, "name": "乐山市扶贫开发局", "type": 2 },
    { "id": 2749, "pid": 288, "name": "乐山市科技局", "type": 2 },
    { "id": 2750, "pid": 288, "name": "乐山市民族宗教委", "type": 2 },
    { "id": 2751, "pid": 288, "name": "乐山市公安局", "type": 2 },
    { "id": 2752, "pid": 288, "name": "乐山市民政局", "type": 2 },
    { "id": 2753, "pid": 288, "name": "乐山市司法局", "type": 2 },
    { "id": 2754, "pid": 288, "name": "乐山市财政局", "type": 2 },
    { "id": 2755, "pid": 288, "name": "乐山市人力资源社会保障局", "type": 2 },
    { "id": 2756, "pid": 288, "name": "乐山市自然资源局", "type": 2 },
    { "id": 2757, "pid": 288, "name": "乐山市生态环境局", "type": 2 },
    { "id": 2758, "pid": 288, "name": "乐山市住房城乡建设局", "type": 2 },
    { "id": 2759, "pid": 288, "name": "乐山市交通运输局", "type": 2 },
    { "id": 2760, "pid": 288, "name": "乐山市公路建设服务中心党委", "type": 2 },
    { "id": 2761, "pid": 288, "name": "乐山市水务局", "type": 2 },
    { "id": 2762, "pid": 288, "name": "乐山市农业农村局", "type": 2 },
    { "id": 2763, "pid": 288, "name": "乐山市商务局", "type": 2 },
    { "id": 2764, "pid": 288, "name": "乐山市文化广电旅游局", "type": 2 },
    { "id": 2765, "pid": 288, "name": "乐山市卫生健康委", "type": 2 },
    { "id": 2766, "pid": 288, "name": "乐山市退役军人局", "type": 2 },
    { "id": 2767, "pid": 288, "name": "乐山市应急局", "type": 2 },
    { "id": 2768, "pid": 288, "name": "乐山市审计局", "type": 2 },
    { "id": 2769, "pid": 288, "name": "乐山市市场监管局", "type": 2 },
    { "id": 2770, "pid": 288, "name": "乐山市统计局", "type": 2 },
    { "id": 2771, "pid": 288, "name": "乐山市营商环境局", "type": 2 },
    { "id": 2772, "pid": 288, "name": "乐山市机关事务局", "type": 2 },
    { "id": 2773, "pid": 288, "name": "乐山市信访局", "type": 2 },
    { "id": 2774, "pid": 288, "name": "乐山市林业园林局", "type": 2 },
    { "id": 2775, "pid": 288, "name": "乐山市城管局", "type": 2 },
    { "id": 2776, "pid": 288, "name": "乐山市医保局", "type": 2 },
    { "id": 2777, "pid": 288, "name": "乐山市体育局", "type": 2 },
    { "id": 2778, "pid": 288, "name": "乐山市苏稽新区管委会党委", "type": 2 },
    { "id": 2779, "pid": 288, "name": "乐山市粮食和物资储备中心", "type": 2 },
    { "id": 2780, "pid": 288, "name": "乐山市供销社", "type": 2 },
    { "id": 2781, "pid": 288, "name": "乐山国家安全局", "type": 2 },
    { "id": 2782, "pid": 288, "name": "乐山市税务局", "type": 2 },
    { "id": 2783, "pid": 288, "name": "乐山市气象局", "type": 2 },
    { "id": 2784, "pid": 288, "name": "乐山市烟草专卖局", "type": 2 },
    { "id": 2785, "pid": 288, "name": "乐山市总工会", "type": 2 },
    { "id": 2786, "pid": 288, "name": "乐山日报社", "type": 2 },
    { "id": 2787, "pid": 288, "name": "乐山广播电视台", "type": 2 },
    { "id": 2788, "pid": 288, "name": "乐山市残联", "type": 2 },
    { "id": 2789, "pid": 288, "name": "乐山市委政策研究室", "type": 2 },
    { "id": 2790, "pid": 288, "name": "乐山市委编办", "type": 2 },
    { "id": 2791, "pid": 288, "name": "乐山市直机关工委", "type": 2 },
    { "id": 2792, "pid": 288, "name": "乐山市委目标绩效管理办公室", "type": 2 },
    { "id": 2793, "pid": 288, "name": "乐山市委党史和地志研究室", "type": 2 },
    { "id": 2794, "pid": 288, "name": "乐山市数字经济局", "type": 2 },
    { "id": 2795, "pid": 288, "name": "乐山市金融工作局", "type": 2 },
    { "id": 2796, "pid": 288, "name": "乐山市人防办", "type": 2 },
    { "id": 2797, "pid": 288, "name": "乐山市心连心服务中心", "type": 2 },
    { "id": 2798, "pid": 288, "name": "乐山市公共资源交易服务中心", "type": 2 },
    { "id": 2799, "pid": 288, "name": "乐山团市委", "type": 2 },
    { "id": 2800, "pid": 288, "name": "乐山市妇联", "type": 2 },
    { "id": 2801, "pid": 288, "name": "乐山市科协", "type": 2 },
    { "id": 2802, "pid": 288, "name": "四川省广播电视局五二五台", "type": 2 },
    { "id": 2803, "pid": 288, "name": "其他", "type": 2 },
    { "id": 2804, "pid": 289, "name": "南充市委办公室", "type": 2 },
    { "id": 2805, "pid": 289, "name": "南充机要保密局", "type": 2 },
    { "id": 2806, "pid": 289, "name": "南充市人大办公室", "type": 2 },
    { "id": 2807, "pid": 289, "name": "南充市政府办公室", "type": 2 },
    { "id": 2808, "pid": 289, "name": "南充市政府法制办", "type": 2 },
    { "id": 2809, "pid": 289, "name": "南充市政协办公室", "type": 2 },
    { "id": 2810, "pid": 289, "name": "南充市纪委监委", "type": 2 },
    { "id": 2811, "pid": 289, "name": "南充市中级人民法院", "type": 2 },
    { "id": 2812, "pid": 289, "name": "南充市人民检察院", "type": 2 },
    { "id": 2813, "pid": 289, "name": "南充市委组织部", "type": 2 },
    { "id": 2814, "pid": 289, "name": "南充市委宣传部", "type": 2 },
    { "id": 2815, "pid": 289, "name": "南充市委政法委", "type": 2 },
    { "id": 2816, "pid": 289, "name": "南充市委统战部", "type": 2 },
    { "id": 2817, "pid": 289, "name": "南充市直机关工委", "type": 2 },
    { "id": 2818, "pid": 289, "name": "南充市委编办", "type": 2 },
    { "id": 2819, "pid": 289, "name": "南充市委政研室", "type": 2 },
    { "id": 2820, "pid": 289, "name": "南充市委群工局", "type": 2 },
    { "id": 2821, "pid": 289, "name": "南充市委党校", "type": 2 },
    { "id": 2822, "pid": 289, "name": "南充市委防邪办", "type": 2 },
    { "id": 2823, "pid": 289, "name": "南充市对外联络办", "type": 2 },
    { "id": 2824, "pid": 289, "name": "南充市委老干局", "type": 2 },
    { "id": 2825, "pid": 289, "name": "南充市文明办", "type": 2 },
    { "id": 2826, "pid": 289, "name": "南充市委党史研究室", "type": 2 },
    { "id": 2827, "pid": 289, "name": "南充日报社", "type": 2 },
    { "id": 2828, "pid": 289, "name": "南充市广播电视台", "type": 2 },
    { "id": 2829, "pid": 289, "name": "南充市发展改革委", "type": 2 },
    { "id": 2830, "pid": 289, "name": "南充市地志办", "type": 2 },
    { "id": 2831, "pid": 289, "name": "南充市教体局", "type": 2 },
    { "id": 2832, "pid": 289, "name": "南充市科技局", "type": 2 },
    { "id": 2833, "pid": 289, "name": "南充市经信局", "type": 2 },
    { "id": 2834, "pid": 289, "name": "南充市公安局", "type": 2 },
    { "id": 2835, "pid": 289, "name": "南充市司法局", "type": 2 },
    { "id": 2836, "pid": 289, "name": "南充市民政局", "type": 2 },
    { "id": 2837, "pid": 289, "name": "南充市财政局", "type": 2 },
    { "id": 2838, "pid": 289, "name": "南充市人社局", "type": 2 },
    { "id": 2839, "pid": 289, "name": "南充市自然资源和规划局", "type": 2 },
    { "id": 2840, "pid": 289, "name": "南充市生态环境局", "type": 2 },
    { "id": 2841, "pid": 289, "name": "南充市住建局", "type": 2 },
    { "id": 2842, "pid": 289, "name": "南充市交通运输局", "type": 2 },
    { "id": 2843, "pid": 289, "name": "南充市水务局", "type": 2 },
    { "id": 2844, "pid": 289, "name": "南充市农业村局", "type": 2 },
    { "id": 2845, "pid": 289, "name": "南充市林业局", "type": 2 },
    { "id": 2846, "pid": 289, "name": "南充市商务局", "type": 2 },
    { "id": 2847, "pid": 289, "name": "南充市文广旅局", "type": 2 },
    { "id": 2848, "pid": 289, "name": "南充市卫健委", "type": 2 },
    { "id": 2849, "pid": 289, "name": "南充市审计局", "type": 2 },
    { "id": 2850, "pid": 289, "name": "南充市国资委", "type": 2 },
    { "id": 2851, "pid": 289, "name": "南充市城管执法局", "type": 2 },
    { "id": 2852, "pid": 289, "name": "南充市应急管理局", "type": 2 },
    { "id": 2853, "pid": 289, "name": "南充市统计局", "type": 2 },
    { "id": 2854, "pid": 289, "name": "南充市金融局", "type": 2 },
    { "id": 2855, "pid": 289, "name": "南充市扶贫移民局", "type": 2 },
    { "id": 2856, "pid": 289, "name": "南充市市场监管局", "type": 2 },
    { "id": 2857, "pid": 289, "name": "南充经济开发区", "type": 2 },
    { "id": 2858, "pid": 289, "name": "南充市政务服务管理局", "type": 2 },
    { "id": 2859, "pid": 289, "name": "南充驻北京联络处", "type": 2 },
    { "id": 2860, "pid": 289, "name": "南充驻成都办事处", "type": 2 },
    { "id": 2861, "pid": 289, "name": "南充市人防办", "type": 2 },
    { "id": 2862, "pid": 289, "name": "南充市监狱", "type": 2 },
    { "id": 2863, "pid": 289, "name": "南充市档案馆", "type": 2 },
    { "id": 2864, "pid": 289, "name": "南充市房管局", "type": 2 },
    { "id": 2865, "pid": 289, "name": "南充市经济合作和外事局", "type": 2 },
    { "id": 2866, "pid": 289, "name": "南充市供销社", "type": 2 },
    { "id": 2867, "pid": 289, "name": "南充市公路局", "type": 2 },
    { "id": 2868, "pid": 289, "name": "南充市航务管理局", "type": 2 },
    { "id": 2869, "pid": 289, "name": "南充市升管局", "type": 2 },
    { "id": 2870, "pid": 289, "name": "南充市农科院", "type": 2 },
    { "id": 2871, "pid": 289, "name": "南充市疾控中心", "type": 2 },
    { "id": 2872, "pid": 289, "name": "南充市总工会", "type": 2 },
    { "id": 2873, "pid": 289, "name": "南充团市委", "type": 2 },
    { "id": 2874, "pid": 289, "name": "南充市妇联", "type": 2 },
    { "id": 2875, "pid": 289, "name": "南充市社科联", "type": 2 },
    { "id": 2876, "pid": 289, "name": "南充市文联", "type": 2 },
    { "id": 2877, "pid": 289, "name": "南充市科协", "type": 2 },
    { "id": 2878, "pid": 289, "name": "南充市红十字会", "type": 2 },
    { "id": 2879, "pid": 289, "name": "南充市残联", "type": 2 },
    { "id": 2880, "pid": 289, "name": "南充市贸促会", "type": 2 },
    { "id": 2881, "pid": 289, "name": "南充市工商联", "type": 2 },
    { "id": 2882, "pid": 289, "name": "南充市税务局", "type": 2 },
    { "id": 2883, "pid": 289, "name": "南充出入境检验检疫局", "type": 2 },
    { "id": 2884, "pid": 289, "name": "成都海关驻南充办事处", "type": 2 },
    { "id": 2885, "pid": 289, "name": "国家统计局南充调查队", "type": 2 },
    { "id": 2886, "pid": 289, "name": "南充国安局", "type": 2 },
    { "id": 2887, "pid": 289, "name": "南充水文局", "type": 2 },
    { "id": 2888, "pid": 289, "name": "国网南充供电公司", "type": 2 },
    { "id": 2889, "pid": 289, "name": "人行南充市中心支行", "type": 2 },
    { "id": 2890, "pid": 289, "name": "南充银监分局", "type": 2 },
    { "id": 2891, "pid": 289, "name": "南充市气象局", "type": 2 },
    { "id": 2892, "pid": 289, "name": "南充市邮政管理局", "type": 2 },
    { "id": 2893, "pid": 289, "name": "民革南充市委", "type": 2 },
    { "id": 2894, "pid": 289, "name": "九三学社南充市委", "type": 2 },
    { "id": 2895, "pid": 289, "name": "民盟南充市委", "type": 2 },
    { "id": 2896, "pid": 289, "name": "民建南充市委", "type": 2 },
    { "id": 2897, "pid": 289, "name": "民进南充市委", "type": 2 },
    { "id": 2898, "pid": 289, "name": "致公党南充市工委", "type": 2 },
    { "id": 2899, "pid": 289, "name": "南充市目标办", "type": 2 },
    { "id": 2900, "pid": 289, "name": "南充市民宗局", "type": 2 },
    { "id": 2901, "pid": 289, "name": "省蚕种场", "type": 2 },
    { "id": 2902, "pid": 289, "name": "省蚕研所", "type": 2 },
    { "id": 2903, "pid": 289, "name": "南充市烟草专卖局", "type": 2 },
    { "id": 2904, "pid": 289, "name": "南充广电网络公司", "type": 2 },
    { "id": 2905, "pid": 289, "name": "四川天府银行", "type": 2 },
    { "id": 2906, "pid": 289, "name": "南充市道路运输管理局", "type": 2 },
    { "id": 2907, "pid": 289, "name": "704台", "type": 2 },
    { "id": 2908, "pid": 289, "name": "省蚕丝校", "type": 2 },
    { "id": 2909, "pid": 289, "name": "其他", "type": 2 },
    { "id": 2910, "pid": 290, "name": "眉山市纪委监委", "type": 2 },
    { "id": 2911, "pid": 290, "name": "眉山市中级人民法院", "type": 2 },
    { "id": 2912, "pid": 290, "name": "眉山市人民检察院", "type": 2 },
    { "id": 2913, "pid": 290, "name": "眉山市委办公室", "type": 2 },
    { "id": 2914, "pid": 290, "name": "眉山市人大常委会办公室", "type": 2 },
    { "id": 2915, "pid": 290, "name": "眉山市政府办公室", "type": 2 },
    { "id": 2916, "pid": 290, "name": "眉山市政协办公室", "type": 2 },
    { "id": 2917, "pid": 290, "name": "眉山市委组织部", "type": 2 },
    { "id": 2918, "pid": 290, "name": "眉山市委宣传部", "type": 2 },
    { "id": 2919, "pid": 290, "name": "眉山市委统战部", "type": 2 },
    { "id": 2920, "pid": 290, "name": "眉山市委政法委", "type": 2 },
    { "id": 2921, "pid": 290, "name": "眉山市委政研室", "type": 2 },
    { "id": 2922, "pid": 290, "name": "眉山市委外办", "type": 2 },
    { "id": 2923, "pid": 290, "name": "眉山市委编办", "type": 2 },
    { "id": 2924, "pid": 290, "name": "眉山市直机关工委", "type": 2 },
    { "id": 2925, "pid": 290, "name": "眉山市委巡察办", "type": 2 },
    { "id": 2926, "pid": 290, "name": "眉山市委老干部局", "type": 2 },
    { "id": 2927, "pid": 290, "name": "眉山市委目标绩效办", "type": 2 },
    { "id": 2928, "pid": 290, "name": "眉山市委保密机要局", "type": 2 },
    { "id": 2929, "pid": 290, "name": "眉山市发展改革委", "type": 2 },
    { "id": 2930, "pid": 290, "name": "眉山市教体局", "type": 2 },
    { "id": 2931, "pid": 290, "name": "眉山市公安局", "type": 2 },
    { "id": 2932, "pid": 290, "name": "眉山国安局", "type": 2 },
    { "id": 2933, "pid": 290, "name": "眉山市经济和信息化局", "type": 2 },
    { "id": 2934, "pid": 290, "name": "眉山市科技局", "type": 2 },
    { "id": 2935, "pid": 290, "name": "眉山市生态环境局", "type": 2 },
    { "id": 2936, "pid": 290, "name": "眉山市交通运输局", "type": 2 },
    { "id": 2937, "pid": 290, "name": "眉山市农业农村局", "type": 2 },
    { "id": 2938, "pid": 290, "name": "眉山市财政局", "type": 2 },
    { "id": 2939, "pid": 290, "name": "眉山市总工会", "type": 2 },
    { "id": 2940, "pid": 290, "name": "眉山市文广旅局", "type": 2 },
    { "id": 2941, "pid": 290, "name": "眉山市退役军人事务局", "type": 2 },
    { "id": 2942, "pid": 290, "name": "眉山市审计局", "type": 2 },
    { "id": 2943, "pid": 290, "name": "眉山市市场监管局", "type": 2 },
    { "id": 2944, "pid": 290, "name": "眉山市统计局", "type": 2 },
    { "id": 2945, "pid": 290, "name": "眉山市林业局", "type": 2 },
    { "id": 2946, "pid": 290, "name": "眉山市委党校", "type": 2 },
    { "id": 2947, "pid": 290, "name": "眉山市公共服务中心", "type": 2 },
    { "id": 2948, "pid": 290, "name": "眉山市税务局", "type": 2 },
    { "id": 2949, "pid": 290, "name": "眉山市应急管理局", "type": 2 },
    { "id": 2950, "pid": 290, "name": "眉山市档案馆", "type": 2 },
    { "id": 2951, "pid": 290, "name": "眉山市住房城乡建设局", "type": 2 },
    { "id": 2952, "pid": 290, "name": "眉山市水利局", "type": 2 },
    { "id": 2953, "pid": 290, "name": "眉山市商务局", "type": 2 },
    { "id": 2954, "pid": 290, "name": "眉山市经济合作局", "type": 2 },
    { "id": 2955, "pid": 290, "name": "眉山市卫生健康委", "type": 2 },
    { "id": 2956, "pid": 290, "name": "眉山市国资委", "type": 2 },
    { "id": 2957, "pid": 290, "name": "眉山市信访局", "type": 2 },
    { "id": 2958, "pid": 290, "name": "眉山市机关事务管理局", "type": 2 },
    { "id": 2959, "pid": 290, "name": "眉山日报社", "type": 2 },
    { "id": 2960, "pid": 290, "name": "眉山市气象局", "type": 2 },
    { "id": 2961, "pid": 290, "name": "眉山市金融工作局", "type": 2 },
    { "id": 2962, "pid": 290, "name": "眉山市史志编纂中心", "type": 2 },
    { "id": 2963, "pid": 290, "name": "国家统计局眉山调查队", "type": 2 },
    { "id": 2964, "pid": 290, "name": "眉山市医疗保障局", "type": 2 },
    { "id": 2965, "pid": 290, "name": "眉山市住房公积金管理中心", "type": 2 },
    { "id": 2966, "pid": 290, "name": "眉山市邮政管理局", "type": 2 },
    { "id": 2967, "pid": 290, "name": "眉山市广播电视台", "type": 2 },
    { "id": 2968, "pid": 290, "name": "眉山市民政局", "type": 2 },
    { "id": 2969, "pid": 290, "name": "眉山市政务服务管理局", "type": 2 },
    { "id": 2970, "pid": 290, "name": "眉山市人防办", "type": 2 },
    { "id": 2971, "pid": 290, "name": "眉山市数字经济发展局", "type": 2 },
    { "id": 2972, "pid": 290, "name": "眉山市司法局", "type": 2 },
    { "id": 2973, "pid": 290, "name": "眉山市人力资源社会保障局", "type": 2 },
    { "id": 2974, "pid": 290, "name": "眉山市自然资源局", "type": 2 },
    { "id": 2975, "pid": 290, "name": "眉山团市委", "type": 2 },
    { "id": 2976, "pid": 290, "name": "眉山市妇联", "type": 2 },
    { "id": 2977, "pid": 290, "name": "眉山市科协", "type": 2 },
    { "id": 2978, "pid": 290, "name": "眉山市工商联", "type": 2 },
    { "id": 2979, "pid": 290, "name": "眉山市残联", "type": 2 },
    { "id": 2980, "pid": 290, "name": "眉山市文联", "type": 2 },
    { "id": 2981, "pid": 290, "name": "眉山市社科联", "type": 2 },
    { "id": 2982, "pid": 290, "name": "眉山市红十字会", "type": 2 },
    { "id": 2983, "pid": 290, "name": "眉山市贸促会", "type": 2 },
    { "id": 2984, "pid": 290, "name": "其他", "type": 2 },
    { "id": 2985, "pid": 291, "name": "宜宾市委办", "type": 2 },
    { "id": 2986, "pid": 291, "name": "宜宾市委组织部", "type": 2 },
    { "id": 2987, "pid": 291, "name": "宜宾市委宣传部", "type": 2 },
    { "id": 2988, "pid": 291, "name": "宜宾市委编办", "type": 2 },
    { "id": 2989, "pid": 291, "name": "宜宾团市委", "type": 2 },
    { "id": 2990, "pid": 291, "name": "宜宾市文广旅游局", "type": 2 },
    { "id": 2991, "pid": 291, "name": "宜宾国安局", "type": 2 },
    { "id": 2992, "pid": 291, "name": "宜宾市退役军人局", "type": 2 },
    { "id": 2993, "pid": 291, "name": "宜宾市政务服务非公经济局", "type": 2 },
    { "id": 2994, "pid": 291, "name": "宜宾市财政局", "type": 2 },
    { "id": 2995, "pid": 291, "name": "宜宾市科技局", "type": 2 },
    { "id": 2996, "pid": 291, "name": "宜宾市邮政管理局", "type": 2 },
    { "id": 2997, "pid": 291, "name": "宜宾市住房公积金中心", "type": 2 },
    { "id": 2998, "pid": 291, "name": "宜宾市地震监测中心", "type": 2 },
    { "id": 2999, "pid": 291, "name": "宜宾市气象局", "type": 2 },
    { "id": 3000, "pid": 291, "name": "宜宾市金融工作局", "type": 2 },
    { "id": 3001, "pid": 291, "name": "宜宾市人大常委会", "type": 2 },
    { "id": 3002, "pid": 291, "name": "宜宾市检察院", "type": 2 },
    { "id": 3003, "pid": 291, "name": "宜宾市委统战部", "type": 2 },
    { "id": 3004, "pid": 291, "name": "宜宾市委网信办", "type": 2 },
    { "id": 3005, "pid": 291, "name": "宜宾市委人才工作局", "type": 2 },
    { "id": 3006, "pid": 291, "name": "宜宾市妇联", "type": 2 },
    { "id": 3007, "pid": 291, "name": "宜宾市卫生健康委", "type": 2 },
    { "id": 3008, "pid": 291, "name": "宜宾日报社", "type": 2 },
    { "id": 3009, "pid": 291, "name": "宜宾市应急管理局", "type": 2 },
    { "id": 3010, "pid": 291, "name": "宜宾市残联", "type": 2 },
    { "id": 3011, "pid": 291, "name": "宜宾市税务局", "type": 2 },
    { "id": 3012, "pid": 291, "name": "宜宾市工业军民融合局", "type": 2 },
    { "id": 3013, "pid": 291, "name": "宜宾市住房城乡建设局", "type": 2 },
    { "id": 3014, "pid": 291, "name": "宜宾市农业农村局", "type": 2 },
    { "id": 3015, "pid": 291, "name": "宜宾市供销社", "type": 2 },
    { "id": 3016, "pid": 291, "name": "宜宾市政府办", "type": 2 },
    { "id": 3017, "pid": 291, "name": "宜宾市委政研室", "type": 2 },
    { "id": 3018, "pid": 291, "name": "宜宾市委党史研究室", "type": 2 },
    { "id": 3019, "pid": 291, "name": "宜宾市总工会", "type": 2 },
    { "id": 3020, "pid": 291, "name": "宜宾市科协", "type": 2 },
    { "id": 3021, "pid": 291, "name": "宜宾市文联", "type": 2 },
    { "id": 3022, "pid": 291, "name": "宜宾市委政法委", "type": 2 },
    { "id": 3023, "pid": 291, "name": "宜宾市民政局", "type": 2 },
    { "id": 3024, "pid": 291, "name": "宜宾市信访局", "type": 2 },
    { "id": 3025, "pid": 291, "name": "宜宾市人防办", "type": 2 },
    { "id": 3026, "pid": 291, "name": "宜宾国调队", "type": 2 },
    { "id": 3027, "pid": 291, "name": "宜宾市交通运输局", "type": 2 },
    { "id": 3028, "pid": 291, "name": "宜宾海事局", "type": 2 },
    { "id": 3029, "pid": 291, "name": "宜宾市自然资源规划局", "type": 2 },
    { "id": 3030, "pid": 291, "name": "宜宾市水利局", "type": 2 },
    { "id": 3031, "pid": 291, "name": "宜宾市烟草专卖局（公司）", "type": 2 },
    { "id": 3032, "pid": 291, "name": "宜宾市法院", "type": 2 },
    { "id": 3033, "pid": 291, "name": "宜宾市委保密机要局", "type": 2 },
    { "id": 3034, "pid": 291, "name": "宜宾市委机关事务局", "type": 2 },
    { "id": 3035, "pid": 291, "name": "宜宾市委老干局", "type": 2 },
    { "id": 3036, "pid": 291, "name": "宜宾市委讲师团", "type": 2 },
    { "id": 3037, "pid": 291, "name": "宜宾市红十字会", "type": 2 },
    { "id": 3038, "pid": 291, "name": "宜宾市司法局", "type": 2 },
    { "id": 3039, "pid": 291, "name": "宜宾市审计局", "type": 2 },
    { "id": 3040, "pid": 291, "name": "宜宾市医保局", "type": 2 },
    { "id": 3041, "pid": 291, "name": "宜宾市统计局", "type": 2 },
    { "id": 3042, "pid": 291, "name": "宜宾市双城服务局", "type": 2 },
    { "id": 3043, "pid": 291, "name": "宜宾市市场监管局", "type": 2 },
    { "id": 3044, "pid": 291, "name": "宜宾市林业竹业局", "type": 2 },
    { "id": 3045, "pid": 291, "name": "长江宜宾航道局", "type": 2 },
    { "id": 3046, "pid": 291, "name": "宜宾市政协", "type": 2 },
    { "id": 3047, "pid": 291, "name": "宜宾市纪委监委", "type": 2 },
    { "id": 3048, "pid": 291, "name": "宜宾市委目标绩效办", "type": 2 },
    { "id": 3049, "pid": 291, "name": "宜宾市档案馆", "type": 2 },
    { "id": 3050, "pid": 291, "name": "宜宾市委党校", "type": 2 },
    { "id": 3051, "pid": 291, "name": "宜宾市社科联", "type": 2 },
    { "id": 3052, "pid": 291, "name": "宜宾市公安局", "type": 2 },
    { "id": 3053, "pid": 291, "name": "宜宾市人力资源社会保障局", "type": 2 },
    { "id": 3054, "pid": 291, "name": "宜宾市经合外事局", "type": 2 },
    { "id": 3055, "pid": 291, "name": "宜宾市发展改革委", "type": 2 },
    { "id": 3056, "pid": 291, "name": "宜宾市教育体育局", "type": 2 },
    { "id": 3057, "pid": 291, "name": "宜宾市商务局", "type": 2 },
    { "id": 3058, "pid": 291, "name": "宜宾市贸促会", "type": 2 },
    { "id": 3059, "pid": 291, "name": "宜宾市生态环境局", "type": 2 },
    { "id": 3060, "pid": 291, "name": "宜宾市扶贫开发局", "type": 2 },
    { "id": 3061, "pid": 291, "name": "宜宾市国资委", "type": 2 },
    { "id": 3062, "pid": 291, "name": "其他", "type": 2 },
    { "id": 3063, "pid": 292, "name": "广安市纪委监委", "type": 2 },
    { "id": 3064, "pid": 292, "name": "广安市中院", "type": 2 },
    { "id": 3065, "pid": 292, "name": "广安市检察院", "type": 2 },
    { "id": 3066, "pid": 292, "name": "广安市委办", "type": 2 },
    { "id": 3067, "pid": 292, "name": "广安市人大常委会", "type": 2 },
    { "id": 3068, "pid": 292, "name": "广安市政府办", "type": 2 },
    { "id": 3069, "pid": 292, "name": "广安市政协", "type": 2 },
    { "id": 3070, "pid": 292, "name": "广安市委组织部", "type": 2 },
    { "id": 3071, "pid": 292, "name": "广安市委宣传部", "type": 2 },
    { "id": 3072, "pid": 292, "name": "广安市委统战部", "type": 2 },
    { "id": 3073, "pid": 292, "name": "广安市委政法委", "type": 2 },
    { "id": 3074, "pid": 292, "name": "广安市委编办", "type": 2 },
    { "id": 3075, "pid": 292, "name": "广安市直工委", "type": 2 },
    { "id": 3076, "pid": 292, "name": "广安市委老干局", "type": 2 },
    { "id": 3077, "pid": 292, "name": "广安市发改委", "type": 2 },
    { "id": 3078, "pid": 292, "name": "广安市经信局", "type": 2 },
    { "id": 3079, "pid": 292, "name": "广安市教体局", "type": 2 },
    { "id": 3080, "pid": 292, "name": "广安市科技局", "type": 2 },
    { "id": 3081, "pid": 292, "name": "广安市公安局", "type": 2 },
    { "id": 3082, "pid": 292, "name": "广安市民政局", "type": 2 },
    { "id": 3083, "pid": 292, "name": "广安市司法局", "type": 2 },
    { "id": 3084, "pid": 292, "name": "广安市财政局", "type": 2 },
    { "id": 3085, "pid": 292, "name": "广安市人社局", "type": 2 },
    { "id": 3086, "pid": 292, "name": "广安市自然资源规划局", "type": 2 },
    { "id": 3087, "pid": 292, "name": "广安市生态环境局", "type": 2 },
    { "id": 3088, "pid": 292, "name": "广安市住建局", "type": 2 },
    { "id": 3089, "pid": 292, "name": "广安市交通运输局", "type": 2 },
    { "id": 3090, "pid": 292, "name": "广安市水务局", "type": 2 },
    { "id": 3091, "pid": 292, "name": "广安市农业农村局", "type": 2 },
    { "id": 3092, "pid": 292, "name": "广安市商务局", "type": 2 },
    { "id": 3093, "pid": 292, "name": "广安市文广旅局", "type": 2 },
    { "id": 3094, "pid": 292, "name": "广安市卫健委", "type": 2 },
    { "id": 3095, "pid": 292, "name": "广安市退役军人事务局", "type": 2 },
    { "id": 3096, "pid": 292, "name": "广安市应急管理局", "type": 2 },
    { "id": 3097, "pid": 292, "name": "广安市审计局", "type": 2 },
    { "id": 3098, "pid": 292, "name": "广安市国资委", "type": 2 },
    { "id": 3099, "pid": 292, "name": "广安市市场监管局", "type": 2 },
    { "id": 3100, "pid": 292, "name": "广安市统计局", "type": 2 },
    { "id": 3101, "pid": 292, "name": "广安市机关事务管理局", "type": 2 },
    { "id": 3102, "pid": 292, "name": "广安市扶贫开发局", "type": 2 },
    { "id": 3103, "pid": 292, "name": "广安市信访局", "type": 2 },
    { "id": 3104, "pid": 292, "name": "广安市金融工作局", "type": 2 },
    { "id": 3105, "pid": 292, "name": "广安市经济合作局", "type": 2 },
    { "id": 3106, "pid": 292, "name": "广安市林业局", "type": 2 },
    { "id": 3107, "pid": 292, "name": "广安市医疗保障局", "type": 2 },
    { "id": 3108, "pid": 292, "name": "广安市城管执法局", "type": 2 },
    { "id": 3109, "pid": 292, "name": "广安市政务服务管理局", "type": 2 },
    { "id": 3110, "pid": 292, "name": "邓小平故里管理局", "type": 2 },
    { "id": 3111, "pid": 292, "name": "广安市委党史研究室", "type": 2 },
    { "id": 3112, "pid": 292, "name": "广安市委党校", "type": 2 },
    { "id": 3113, "pid": 292, "name": "广安市档案馆", "type": 2 },
    { "id": 3114, "pid": 292, "name": "广安邓小平图书馆", "type": 2 },
    { "id": 3115, "pid": 292, "name": "广安日报社", "type": 2 },
    { "id": 3116, "pid": 292, "name": "广安广播电视台", "type": 2 },
    { "id": 3117, "pid": 292, "name": "广安市公共资源交易中心", "type": 2 },
    { "id": 3118, "pid": 292, "name": "广安市供销社", "type": 2 },
    { "id": 3119, "pid": 292, "name": "广安市公积金管理中心", "type": 2 },
    { "id": 3120, "pid": 292, "name": "广安市总工会", "type": 2 },
    { "id": 3121, "pid": 292, "name": "广安团市委", "type": 2 },
    { "id": 3122, "pid": 292, "name": "广安市妇联", "type": 2 },
    { "id": 3123, "pid": 292, "name": "广安市科协", "type": 2 },
    { "id": 3124, "pid": 292, "name": "广安市残联", "type": 2 },
    { "id": 3125, "pid": 292, "name": "广安市贸促会", "type": 2 },
    { "id": 3126, "pid": 292, "name": "广安市工商联", "type": 2 },
    { "id": 3127, "pid": 292, "name": "广安国安局", "type": 2 },
    { "id": 3128, "pid": 292, "name": "广安市税务局", "type": 2 },
    { "id": 3129, "pid": 292, "name": "广安市气象局", "type": 2 },
    { "id": 3130, "pid": 292, "name": "广安调查队", "type": 2 },
    { "id": 3131, "pid": 292, "name": "广安市红十字会", "type": 2 },
    { "id": 3132, "pid": 292, "name": "其他", "type": 2 },
    { "id": 3133, "pid": 293, "name": "达州市纪委监委", "type": 2 },
    { "id": 3134, "pid": 293, "name": "达州市中级人民法院", "type": 2 },
    { "id": 3135, "pid": 293, "name": "达州市人民检察院", "type": 2 },
    { "id": 3136, "pid": 293, "name": "达州市委办公室", "type": 2 },
    { "id": 3137, "pid": 293, "name": "达州市人大常委会办公室", "type": 2 },
    { "id": 3138, "pid": 293, "name": "达州市政府办", "type": 2 },
    { "id": 3139, "pid": 293, "name": "达州市政协办", "type": 2 },
    { "id": 3140, "pid": 293, "name": "达州市委组织部", "type": 2 },
    { "id": 3141, "pid": 293, "name": "达州市委宣传部", "type": 2 },
    { "id": 3142, "pid": 293, "name": "达州市委统战部", "type": 2 },
    { "id": 3143, "pid": 293, "name": "达州市委政法委", "type": 2 },
    { "id": 3144, "pid": 293, "name": "达州市委编办", "type": 2 },
    { "id": 3145, "pid": 293, "name": "达州市直机关工委", "type": 2 },
    { "id": 3146, "pid": 293, "name": "达州市委老干部局", "type": 2 },
    { "id": 3147, "pid": 293, "name": "达州市发展和改革委员会", "type": 2 },
    { "id": 3148, "pid": 293, "name": "达州市经济和信息化局", "type": 2 },
    { "id": 3149, "pid": 293, "name": "达州市教育局", "type": 2 },
    { "id": 3150, "pid": 293, "name": "达州市科学技术局", "type": 2 },
    { "id": 3151, "pid": 293, "name": "达州市委党史研究室", "type": 2 },
    { "id": 3152, "pid": 293, "name": "达州市公安局", "type": 2 },
    { "id": 3153, "pid": 293, "name": "达州国安局", "type": 2 },
    { "id": 3154, "pid": 293, "name": "达州市民政局", "type": 2 },
    { "id": 3155, "pid": 293, "name": "达州市司法局", "type": 2 },
    { "id": 3156, "pid": 293, "name": "达州市财政局", "type": 2 },
    { "id": 3157, "pid": 293, "name": "达州市人力资源和社会保障局", "type": 2 },
    { "id": 3158, "pid": 293, "name": "达州市自然资源和规划局", "type": 2 },
    { "id": 3159, "pid": 293, "name": "达州市生态环境局", "type": 2 },
    { "id": 3160, "pid": 293, "name": "达州市住房和城乡建设局", "type": 2 },
    { "id": 3161, "pid": 293, "name": "达州市交通运输局", "type": 2 },
    { "id": 3162, "pid": 293, "name": "达州市水务局", "type": 2 },
    { "id": 3163, "pid": 293, "name": "达州市农业农村局", "type": 2 },
    { "id": 3164, "pid": 293, "name": "达州市商务局", "type": 2 },
    { "id": 3165, "pid": 293, "name": "达州市文化体育和旅游局", "type": 2 },
    { "id": 3166, "pid": 293, "name": "达州市卫生健康委员会", "type": 2 },
    { "id": 3167, "pid": 293, "name": "达州市退役军人事务局", "type": 2 },
    { "id": 3168, "pid": 293, "name": "达州市应急管理局", "type": 2 },
    { "id": 3169, "pid": 293, "name": "达州市审计局", "type": 2 },
    { "id": 3170, "pid": 293, "name": "达州市国有资产监督管理委员会", "type": 2 },
    { "id": 3171, "pid": 293, "name": "达州市市场监督管理局", "type": 2 },
    { "id": 3172, "pid": 293, "name": "达州市统计局", "type": 2 },
    { "id": 3173, "pid": 293, "name": "达州市扶贫开发局", "type": 2 },
    { "id": 3174, "pid": 293, "name": "达州市信访局", "type": 2 },
    { "id": 3175, "pid": 293, "name": "达州市经济合作和外事局", "type": 2 },
    { "id": 3176, "pid": 293, "name": "达州市政务服务管理局", "type": 2 },
    { "id": 3177, "pid": 293, "name": "达州市林业局", "type": 2 },
    { "id": 3178, "pid": 293, "name": "达州市城市管理行政执法局", "type": 2 },
    { "id": 3179, "pid": 293, "name": "达州市医疗保障局", "type": 2 },
    { "id": 3180, "pid": 293, "name": "达州市委党校", "type": 2 },
    { "id": 3181, "pid": 293, "name": "达州日报社", "type": 2 },
    { "id": 3182, "pid": 293, "name": "达州市公共资源交易服务中心", "type": 2 },
    { "id": 3183, "pid": 293, "name": "达州市供销合作社", "type": 2 },
    { "id": 3184, "pid": 293, "name": "达州市公路管理局", "type": 2 },
    { "id": 3185, "pid": 293, "name": "达州市总工会", "type": 2 },
    { "id": 3186, "pid": 293, "name": "国家税务总局达州市税务局", "type": 2 },
    { "id": 3187, "pid": 293, "name": "达州市气象局", "type": 2 },
    { "id": 3188, "pid": 293, "name": "达州市委老干部休养所", "type": 2 },
    { "id": 3189, "pid": 293, "name": "达州市住房公积金管理中心", "type": 2 },
    { "id": 3190, "pid": 293, "name": "达州市科协", "type": 2 },
    { "id": 3191, "pid": 293, "name": "达州市残联", "type": 2 },
    { "id": 3192, "pid": 293, "name": "达州市委政研室", "type": 2 },
    { "id": 3193, "pid": 293, "name": "达州市委巡察办", "type": 2 },
    { "id": 3194, "pid": 293, "name": "达州市委目标绩效办", "type": 2 },
    { "id": 3195, "pid": 293, "name": "达州市委网信办", "type": 2 },
    { "id": 3196, "pid": 293, "name": "达州市口岸物流办", "type": 2 },
    { "id": 3197, "pid": 293, "name": "达州市数字经济局", "type": 2 },
    { "id": 3198, "pid": 293, "name": "达州市中医药管理局", "type": 2 },
    { "id": 3199, "pid": 293, "name": "达州市机关事务服务中心", "type": 2 },
    { "id": 3200, "pid": 293, "name": "达州团市委", "type": 2 },
    { "id": 3201, "pid": 293, "name": "达州市妇联", "type": 2 },
    { "id": 3202, "pid": 293, "name": "达州市侨联", "type": 2 },
    { "id": 3203, "pid": 293, "name": "达州市红十字会", "type": 2 },
    { "id": 3204, "pid": 293, "name": "达州调查队", "type": 2 },
    { "id": 3205, "pid": 293, "name": "达州市人防办", "type": 2 },
    { "id": 3206, "pid": 293, "name": "达州市邮政管理局", "type": 2 },
    { "id": 3207, "pid": 293, "name": "达州市巴文化研究院", "type": 2 },
    { "id": 3208, "pid": 293, "name": "达州市金融工作局", "type": 2 },
    { "id": 3209, "pid": 293, "name": "达州市农科院", "type": 2 },
    { "id": 3210, "pid": 293, "name": "达州市邮政公司", "type": 2 },
    { "id": 3211, "pid": 293, "name": "达州市广播电视台", "type": 2 },
    { "id": 3212, "pid": 293, "name": "四川广电网络达州分公司", "type": 2 },
    { "id": 3213, "pid": 293, "name": "达州水文局", "type": 2 },
    { "id": 3214, "pid": 293, "name": "达州驻京流动党委", "type": 2 },
    { "id": 3215, "pid": 293, "name": "达州驻渝流动党委", "type": 2 },
    { "id": 3216, "pid": 293, "name": "达州驻蓉流动党委", "type": 2 },
    { "id": 3217, "pid": 293, "name": "达州驻广流动党委", "type": 2 },
    { "id": 3218, "pid": 293, "name": "其他", "type": 2 },
    { "id": 3219, "pid": 294, "name": "雅安市委办公室", "type": 2 },
    { "id": 3220, "pid": 294, "name": "雅安市人大办", "type": 2 },
    { "id": 3221, "pid": 294, "name": "雅安市政府办公室", "type": 2 },
    { "id": 3222, "pid": 294, "name": "雅安市政协办", "type": 2 },
    { "id": 3223, "pid": 294, "name": "雅安市纪委监委", "type": 2 },
    { "id": 3224, "pid": 294, "name": "雅安市法院", "type": 2 },
    { "id": 3225, "pid": 294, "name": "雅安市检察院", "type": 2 },
    { "id": 3226, "pid": 294, "name": "雅安市委组织部", "type": 2 },
    { "id": 3227, "pid": 294, "name": "雅安市委宣传部", "type": 2 },
    { "id": 3228, "pid": 294, "name": "雅安市委统战部", "type": 2 },
    { "id": 3229, "pid": 294, "name": "雅安市委政法委", "type": 2 },
    { "id": 3230, "pid": 294, "name": "雅安市委编办", "type": 2 },
    { "id": 3231, "pid": 294, "name": "雅安市直机关工委", "type": 2 },
    { "id": 3232, "pid": 294, "name": "雅安市委老干部局", "type": 2 },
    { "id": 3233, "pid": 294, "name": "雅安市发改委", "type": 2 },
    { "id": 3234, "pid": 294, "name": "雅安市经信局", "type": 2 },
    { "id": 3235, "pid": 294, "name": "雅安市教育局", "type": 2 },
    { "id": 3236, "pid": 294, "name": "雅安市科技局", "type": 2 },
    { "id": 3237, "pid": 294, "name": "雅安市公安局", "type": 2 },
    { "id": 3238, "pid": 294, "name": "雅安市民政局", "type": 2 },
    { "id": 3239, "pid": 294, "name": "雅安市司法局", "type": 2 },
    { "id": 3240, "pid": 294, "name": "雅安市财政局", "type": 2 },
    { "id": 3241, "pid": 294, "name": "雅安市人社局", "type": 2 },
    { "id": 3242, "pid": 294, "name": "雅安市自然资源和规划局", "type": 2 },
    { "id": 3243, "pid": 294, "name": "雅安市生态环境局", "type": 2 },
    { "id": 3244, "pid": 294, "name": "雅安市住建局", "type": 2 },
    { "id": 3245, "pid": 294, "name": "雅安市交通运输局", "type": 2 },
    { "id": 3246, "pid": 294, "name": "雅安市水利局", "type": 2 },
    { "id": 3247, "pid": 294, "name": "雅安市农业农村局", "type": 2 },
    { "id": 3248, "pid": 294, "name": "雅安市林业局", "type": 2 },
    { "id": 3249, "pid": 294, "name": "雅安市商务局", "type": 2 },
    { "id": 3250, "pid": 294, "name": "雅安市文化体育和旅游局", "type": 2 },
    { "id": 3251, "pid": 294, "name": "雅安市卫生健康委", "type": 2 },
    { "id": 3252, "pid": 294, "name": "雅安市退役军人事务局", "type": 2 },
    { "id": 3253, "pid": 294, "name": "雅安市应急管理局", "type": 2 },
    { "id": 3254, "pid": 294, "name": "雅安市审计局", "type": 2 },
    { "id": 3255, "pid": 294, "name": "雅安市国资委", "type": 2 },
    { "id": 3256, "pid": 294, "name": "雅安市市场监督管理局", "type": 2 },
    { "id": 3257, "pid": 294, "name": "雅安市统计局", "type": 2 },
    { "id": 3258, "pid": 294, "name": "雅安市扶贫开发局", "type": 2 },
    { "id": 3259, "pid": 294, "name": "雅安市信访局", "type": 2 },
    { "id": 3260, "pid": 294, "name": "雅安市经济合作和外事局", "type": 2 },
    { "id": 3261, "pid": 294, "name": "雅安市医疗保障局", "type": 2 },
    { "id": 3262, "pid": 294, "name": "雅安市政务服务和大数据局", "type": 2 },
    { "id": 3263, "pid": 294, "name": "雅安市综合行政执法局", "type": 2 },
    { "id": 3264, "pid": 294, "name": "雅安市民营经济发展局", "type": 2 },
    { "id": 3265, "pid": 294, "name": "雅安市机关事务管理局", "type": 2 },
    { "id": 3266, "pid": 294, "name": "雅安市委党校", "type": 2 },
    { "id": 3267, "pid": 294, "name": "雅安市委党研室", "type": 2 },
    { "id": 3268, "pid": 294, "name": "雅安日报传媒集团", "type": 2 },
    { "id": 3269, "pid": 294, "name": "雅安市档案馆", "type": 2 },
    { "id": 3270, "pid": 294, "name": "雅安市防震减灾中心", "type": 2 },
    { "id": 3271, "pid": 294, "name": "雅安市供销社", "type": 2 },
    { "id": 3272, "pid": 294, "name": "雅安市农业园区", "type": 2 },
    { "id": 3273, "pid": 294, "name": "雅安市总工会", "type": 2 },
    { "id": 3274, "pid": 294, "name": "夹金山干部学院", "type": 2 },
    { "id": 3275, "pid": 294, "name": "共青团雅安市委", "type": 2 },
    { "id": 3276, "pid": 294, "name": "雅安市妇联", "type": 2 },
    { "id": 3277, "pid": 294, "name": "雅安市科协", "type": 2 },
    { "id": 3278, "pid": 294, "name": "雅安市残联", "type": 2 },
    { "id": 3279, "pid": 294, "name": "雅安市红十字会", "type": 2 },
    { "id": 3280, "pid": 294, "name": "雅安国家安全局", "type": 2 },
    { "id": 3281, "pid": 294, "name": "雅安市税务局", "type": 2 },
    { "id": 3282, "pid": 294, "name": "雅安市气象局", "type": 2 },
    { "id": 3283, "pid": 294, "name": "雅安市烟草局", "type": 2 },
    { "id": 3284, "pid": 294, "name": "雅安国调队", "type": 2 },
    { "id": 3285, "pid": 294, "name": "四川省地震局地壳形变观测中心", "type": 2 },
    { "id": 3286, "pid": 294, "name": "雅安邮政管理局", "type": 2 },
    { "id": 3287, "pid": 294, "name": "雅安市公路建设服务中心", "type": 2 },
    { "id": 3288, "pid": 294, "name": "雅安水文水资源勘测局", "type": 2 },
    { "id": 3289, "pid": 294, "name": "（雅安）甘孜州干休所", "type": 2 },
    { "id": 3290, "pid": 294, "name": "雅安发射传输台", "type": 2 },
    { "id": 3291, "pid": 294, "name": "大熊猫国家公园雅安管理分局", "type": 2 },
    { "id": 3292, "pid": 294, "name": "雅安市文旅融合发展服务中心", "type": 2 },
    { "id": 3293, "pid": 294, "name": "其他", "type": 2 },
    { "id": 3294, "pid": 295, "name": "巴中市纪委监委机关", "type": 2 },
    { "id": 3295, "pid": 295, "name": "巴中市中级人民法院", "type": 2 },
    { "id": 3296, "pid": 295, "name": "巴中市检察院", "type": 2 },
    { "id": 3297, "pid": 295, "name": "巴中市委办公室", "type": 2 },
    { "id": 3298, "pid": 295, "name": "巴中市人大常委会办公室", "type": 2 },
    { "id": 3299, "pid": 295, "name": "巴中市政府办公室", "type": 2 },
    { "id": 3300, "pid": 295, "name": "巴中市政协办公室", "type": 2 },
    { "id": 3301, "pid": 295, "name": "巴中市委组织部", "type": 2 },
    { "id": 3302, "pid": 295, "name": "巴中市委宣传部", "type": 2 },
    { "id": 3303, "pid": 295, "name": "巴中市委统战部", "type": 2 },
    { "id": 3304, "pid": 295, "name": "巴中市委政法委", "type": 2 },
    { "id": 3305, "pid": 295, "name": "巴中市委政研室", "type": 2 },
    { "id": 3306, "pid": 295, "name": "巴中市委编办", "type": 2 },
    { "id": 3307, "pid": 295, "name": "巴中市直机关工委", "type": 2 },
    { "id": 3308, "pid": 295, "name": "巴中市委巡察办", "type": 2 },
    { "id": 3309, "pid": 295, "name": "巴中市委老干部局", "type": 2 },
    { "id": 3310, "pid": 295, "name": "巴中市委老区振兴办", "type": 2 },
    { "id": 3311, "pid": 295, "name": "巴中市目标绩效办", "type": 2 },
    { "id": 3312, "pid": 295, "name": "巴中市委保密机要局", "type": 2 },
    { "id": 3313, "pid": 295, "name": "巴中市经济和信息化局", "type": 2 },
    { "id": 3314, "pid": 295, "name": "巴中市科学技术局", "type": 2 },
    { "id": 3315, "pid": 295, "name": "巴中市发展改革委", "type": 2 },
    { "id": 3316, "pid": 295, "name": "巴中市教育和体育局", "type": 2 },
    { "id": 3317, "pid": 295, "name": "巴中市公安局", "type": 2 },
    { "id": 3318, "pid": 295, "name": "巴中市司法局", "type": 2 },
    { "id": 3319, "pid": 295, "name": "巴中市民政局", "type": 2 },
    { "id": 3320, "pid": 295, "name": "巴中市财政局", "type": 2 },
    { "id": 3321, "pid": 295, "name": "巴中市自然资源和规划局", "type": 2 },
    { "id": 3322, "pid": 295, "name": "巴中市住房城乡建设局", "type": 2 },
    { "id": 3323, "pid": 295, "name": "巴中市水利局", "type": 2 },
    { "id": 3324, "pid": 295, "name": "巴中市人力资源社会保障局", "type": 2 },
    { "id": 3325, "pid": 295, "name": "巴中市生态环境局", "type": 2 },
    { "id": 3326, "pid": 295, "name": "巴中市交通运输局", "type": 2 },
    { "id": 3327, "pid": 295, "name": "巴中市农业农村局", "type": 2 },
    { "id": 3328, "pid": 295, "name": "巴中市商务局", "type": 2 },
    { "id": 3329, "pid": 295, "name": "巴中市卫生健康委", "type": 2 },
    { "id": 3330, "pid": 295, "name": "巴中市应急管理局", "type": 2 },
    { "id": 3331, "pid": 295, "name": "巴中市国资委", "type": 2 },
    { "id": 3332, "pid": 295, "name": "巴中市统计局", "type": 2 },
    { "id": 3333, "pid": 295, "name": "巴中市文化广播电视和旅游局", "type": 2 },
    { "id": 3334, "pid": 295, "name": "巴中市退役军人事务局", "type": 2 },
    { "id": 3335, "pid": 295, "name": "巴中市审计局", "type": 2 },
    { "id": 3336, "pid": 295, "name": "巴中市信访局", "type": 2 },
    { "id": 3337, "pid": 295, "name": "巴中市投资促进局", "type": 2 },
    { "id": 3338, "pid": 295, "name": "巴中市医疗保障局", "type": 2 },
    { "id": 3339, "pid": 295, "name": "巴中市市场监管局", "type": 2 },
    { "id": 3340, "pid": 295, "name": "巴中市扶贫开发局", "type": 2 },
    { "id": 3341, "pid": 295, "name": "巴中市政务服务和大数据管理局", "type": 2 },
    { "id": 3342, "pid": 295, "name": "巴中市党史(地方志)办", "type": 2 },
    { "id": 3343, "pid": 295, "name": "巴中市委市政府接待办", "type": 2 },
    { "id": 3344, "pid": 295, "name": "巴中市广播电视台", "type": 2 },
    { "id": 3345, "pid": 295, "name": "巴中市供销社", "type": 2 },
    { "id": 3346, "pid": 295, "name": "巴中市金融工作局", "type": 2 },
    { "id": 3347, "pid": 295, "name": "巴中市林业局", "type": 2 },
    { "id": 3348, "pid": 295, "name": "巴中市城管执法局", "type": 2 },
    { "id": 3349, "pid": 295, "name": "巴中市政务服务和资源交易服务中心", "type": 2 },
    { "id": 3350, "pid": 295, "name": "巴中市委党校", "type": 2 },
    { "id": 3351, "pid": 295, "name": "巴中市档案馆", "type": 2 },
    { "id": 3352, "pid": 295, "name": "巴中日报社", "type": 2 },
    { "id": 3353, "pid": 295, "name": "巴中市机关事务服务中心", "type": 2 },
    { "id": 3354, "pid": 295, "name": "巴中市住房公积金中心", "type": 2 },
    { "id": 3355, "pid": 295, "name": "巴中市南龛产业园管委会", "type": 2 },
    { "id": 3356, "pid": 295, "name": "巴中团市委", "type": 2 },
    { "id": 3357, "pid": 295, "name": "巴中市科协", "type": 2 },
    { "id": 3358, "pid": 295, "name": "巴中市残联", "type": 2 },
    { "id": 3359, "pid": 295, "name": "巴中市总工会", "type": 2 },
    { "id": 3360, "pid": 295, "name": "巴中市妇联", "type": 2 },
    { "id": 3361, "pid": 295, "name": "巴中市侨联", "type": 2 },
    { "id": 3362, "pid": 295, "name": "巴中市工商联", "type": 2 },
    { "id": 3363, "pid": 295, "name": "巴中市红十字会", "type": 2 },
    { "id": 3364, "pid": 295, "name": "巴中市税务局", "type": 2 },
    { "id": 3365, "pid": 295, "name": "巴中市气象局", "type": 2 },
    { "id": 3366, "pid": 295, "name": "巴中市中医药产业促进中心", "type": 2 },
    { "id": 3367, "pid": 295, "name": "巴中市农业创新研究院", "type": 2 },
    { "id": 3368, "pid": 295, "name": "巴中市水文水资源勘测局", "type": 2 },
    { "id": 3369, "pid": 295, "name": "巴中市产品质量检验检测中心", "type": 2 },
    { "id": 3370, "pid": 295, "name": "巴中国家安全局", "type": 2 },
    { "id": 3371, "pid": 295, "name": "巴中市邮政管理局", "type": 2 },
    { "id": 3372, "pid": 295, "name": "国家统计局巴中调查队", "type": 2 },
    { "id": 3373, "pid": 295, "name": "其他", "type": 2 },
    { "id": 3374, "pid": 296, "name": "资阳市纪委监委 ", "type": 2 },
    { "id": 3375, "pid": 296, "name": "资阳市中级人民法院", "type": 2 },
    { "id": 3376, "pid": 296, "name": "资阳市人民检察院", "type": 2 },
    { "id": 3377, "pid": 296, "name": "资阳市委办公室", "type": 2 },
    { "id": 3378, "pid": 296, "name": "资阳市人大常委会办公室", "type": 2 },
    { "id": 3379, "pid": 296, "name": "资阳市政府办公室", "type": 2 },
    { "id": 3380, "pid": 296, "name": "资阳市政协办公室", "type": 2 },
    { "id": 3381, "pid": 296, "name": "资阳市委组织部", "type": 2 },
    { "id": 3382, "pid": 296, "name": "资阳市委宣传部", "type": 2 },
    { "id": 3383, "pid": 296, "name": "资阳市委统战部", "type": 2 },
    { "id": 3384, "pid": 296, "name": "资阳市委政法委", "type": 2 },
    { "id": 3385, "pid": 296, "name": "资阳市委政研室", "type": 2 },
    { "id": 3386, "pid": 296, "name": "资阳市委编办", "type": 2 },
    { "id": 3387, "pid": 296, "name": "资阳市直机关工委", "type": 2 },
    { "id": 3388, "pid": 296, "name": "资阳市委老干部局", "type": 2 },
    { "id": 3389, "pid": 296, "name": "资阳市委保密机要局", "type": 2 },
    { "id": 3390, "pid": 296, "name": "资阳市委目标绩效办", "type": 2 },
    { "id": 3391, "pid": 296, "name": "资阳市委党校", "type": 2 },
    { "id": 3392, "pid": 296, "name": "资阳新闻传媒中心筹备组", "type": 2 },
    { "id": 3393, "pid": 296, "name": "资阳市档案馆", "type": 2 },
    { "id": 3394, "pid": 296, "name": "资阳市发展改革委", "type": 2 },
    { "id": 3395, "pid": 296, "name": "资阳市同城化发展工作局", "type": 2 },
    { "id": 3396, "pid": 296, "name": "资阳市经济和信息化局", "type": 2 },
    { "id": 3397, "pid": 296, "name": "资阳市教育体育局", "type": 2 },
    { "id": 3398, "pid": 296, "name": "资阳市科学技术局", "type": 2 },
    { "id": 3399, "pid": 296, "name": "资阳市公安局", "type": 2 },
    { "id": 3400, "pid": 296, "name": "资阳市民政局", "type": 2 },
    { "id": 3401, "pid": 296, "name": "资阳市司法局", "type": 2 },
    { "id": 3402, "pid": 296, "name": "资阳市财政局", "type": 2 },
    { "id": 3403, "pid": 296, "name": "资阳市人力资源社会保障局", "type": 2 },
    { "id": 3404, "pid": 296, "name": "资阳市自然资源规划局", "type": 2 },
    { "id": 3405, "pid": 296, "name": "资阳市生态环境局", "type": 2 },
    { "id": 3406, "pid": 296, "name": "资阳市住房城乡建设局", "type": 2 },
    { "id": 3407, "pid": 296, "name": "资阳市交通运输局", "type": 2 },
    { "id": 3408, "pid": 296, "name": "资阳市水务局", "type": 2 },
    { "id": 3409, "pid": 296, "name": "资阳市农业农村局", "type": 2 },
    { "id": 3410, "pid": 296, "name": "资阳市商务局", "type": 2 },
    { "id": 3411, "pid": 296, "name": "资阳市文化广电旅游局", "type": 2 },
    { "id": 3412, "pid": 296, "name": "资阳市卫生健康委", "type": 2 },
    { "id": 3413, "pid": 296, "name": "资阳市退役军人事务局", "type": 2 },
    { "id": 3414, "pid": 296, "name": "资阳市应急管理局", "type": 2 },
    { "id": 3415, "pid": 296, "name": "资阳市审计局", "type": 2 },
    { "id": 3416, "pid": 296, "name": "资阳市国资委", "type": 2 },
    { "id": 3417, "pid": 296, "name": "资阳市市场监管局", "type": 2 },
    { "id": 3418, "pid": 296, "name": "资阳市统计局", "type": 2 },
    { "id": 3419, "pid": 296, "name": "资阳市城管行政执法局", "type": 2 },
    { "id": 3420, "pid": 296, "name": "资阳市扶贫开发局", "type": 2 },
    { "id": 3421, "pid": 296, "name": "资阳市信访局", "type": 2 },
    { "id": 3422, "pid": 296, "name": "资阳市金融工作局", "type": 2 },
    { "id": 3423, "pid": 296, "name": "资阳市经济合作外事局", "type": 2 },
    { "id": 3424, "pid": 296, "name": "资阳市医疗保障局", "type": 2 },
    { "id": 3425, "pid": 296, "name": "资阳市政务服务大数据管理局", "type": 2 },
    { "id": 3426, "pid": 296, "name": "资阳市政府研究室", "type": 2 },
    { "id": 3427, "pid": 296, "name": "资阳国家安全局", "type": 2 },
    { "id": 3428, "pid": 296, "name": "资阳市供销社", "type": 2 },
    { "id": 3429, "pid": 296, "name": "资阳市税务局", "type": 2 },
    { "id": 3430, "pid": 296, "name": "资阳市气象局", "type": 2 },
    { "id": 3431, "pid": 296, "name": "资阳市烟草专卖局", "type": 2 },
    { "id": 3432, "pid": 296, "name": "国家统计局资阳调查队", "type": 2 },
    { "id": 3433, "pid": 296, "name": "资阳市总工会", "type": 2 },
    { "id": 3434, "pid": 296, "name": "资阳团市委", "type": 2 },
    { "id": 3435, "pid": 296, "name": "资阳市妇联", "type": 2 },
    { "id": 3436, "pid": 296, "name": "资阳市工商联", "type": 2 },
    { "id": 3437, "pid": 296, "name": "资阳市科协", "type": 2 },
    { "id": 3438, "pid": 296, "name": "资阳市残联", "type": 2 },
    { "id": 3439, "pid": 296, "name": "资阳邮政公司", "type": 2 },
    { "id": 3440, "pid": 296, "name": "资阳广电网络公司", "type": 2 },
    { "id": 3441, "pid": 296, "name": "省716台", "type": 2 },
    { "id": 3442, "pid": 296, "name": "资阳新华文轩", "type": 2 },
    { "id": 3443, "pid": 296, "name": "资阳邮政管理局", "type": 2 },
    { "id": 3444, "pid": 296, "name": "其他", "type": 2 },
    { "id": 3445, "pid": 297, "name": "阿坝州委办", "type": 2 },
    { "id": 3446, "pid": 297, "name": "阿坝州人大", "type": 2 },
    { "id": 3447, "pid": 297, "name": "阿坝州政府办", "type": 2 },
    { "id": 3448, "pid": 297, "name": "阿坝州政协", "type": 2 },
    { "id": 3449, "pid": 297, "name": "阿坝州纪委监委", "type": 2 },
    { "id": 3450, "pid": 297, "name": "阿坝州法院", "type": 2 },
    { "id": 3451, "pid": 297, "name": "阿坝州检察院", "type": 2 },
    { "id": 3452, "pid": 297, "name": "阿坝州委组织部", "type": 2 },
    { "id": 3453, "pid": 297, "name": "阿坝州委宣传部", "type": 2 },
    { "id": 3454, "pid": 297, "name": "阿坝州委统战部", "type": 2 },
    { "id": 3455, "pid": 297, "name": "阿坝州委政法委", "type": 2 },
    { "id": 3456, "pid": 297, "name": "阿坝州直机关工委", "type": 2 },
    { "id": 3457, "pid": 297, "name": "阿坝州委网信办", "type": 2 },
    { "id": 3458, "pid": 297, "name": "阿坝州委党校", "type": 2 },
    { "id": 3459, "pid": 297, "name": "阿坝州委党史研究室", "type": 2 },
    { "id": 3460, "pid": 297, "name": "阿坝州委编办", "type": 2 },
    { "id": 3461, "pid": 297, "name": "阿坝州委政研室", "type": 2 },
    { "id": 3462, "pid": 297, "name": "阿坝州委外办", "type": 2 },
    { "id": 3463, "pid": 297, "name": "阿坝州委保密机要局", "type": 2 },
    { "id": 3464, "pid": 297, "name": "阿坝机关事务管理局", "type": 2 },
    { "id": 3465, "pid": 297, "name": "阿坝州发改委", "type": 2 },
    { "id": 3466, "pid": 297, "name": "阿坝州信访局", "type": 2 },
    { "id": 3467, "pid": 297, "name": "阿坝州经信局", "type": 2 },
    { "id": 3468, "pid": 297, "name": "阿坝州教育局", "type": 2 },
    { "id": 3469, "pid": 297, "name": "阿坝州科技局", "type": 2 },
    { "id": 3470, "pid": 297, "name": "阿坝民宗委", "type": 2 },
    { "id": 3471, "pid": 297, "name": "阿坝州公安局", "type": 2 },
    { "id": 3472, "pid": 297, "name": "阿坝州民政局", "type": 2 },
    { "id": 3473, "pid": 297, "name": "阿坝州司法局", "type": 2 },
    { "id": 3474, "pid": 297, "name": "阿坝州财政局", "type": 2 },
    { "id": 3475, "pid": 297, "name": "阿坝州人社局", "type": 2 },
    { "id": 3476, "pid": 297, "name": "阿坝州自然资源局", "type": 2 },
    { "id": 3477, "pid": 297, "name": "阿坝州住建局", "type": 2 },
    { "id": 3478, "pid": 297, "name": "阿坝州生态环境局", "type": 2 },
    { "id": 3479, "pid": 297, "name": "阿坝州交通局", "type": 2 },
    { "id": 3480, "pid": 297, "name": "阿坝州水务局", "type": 2 },
    { "id": 3481, "pid": 297, "name": "阿坝州农业农村局", "type": 2 },
    { "id": 3482, "pid": 297, "name": "阿坝州林草局", "type": 2 },
    { "id": 3483, "pid": 297, "name": "阿坝州商务局", "type": 2 },
    { "id": 3484, "pid": 297, "name": "阿坝州文体旅游局", "type": 2 },
    { "id": 3485, "pid": 297, "name": "阿坝州卫健委", "type": 2 },
    { "id": 3486, "pid": 297, "name": "阿坝州退役军人事务局", "type": 2 },
    { "id": 3487, "pid": 297, "name": "阿坝州应急局", "type": 2 },
    { "id": 3488, "pid": 297, "name": "阿坝州审计局", "type": 2 },
    { "id": 3489, "pid": 297, "name": "阿坝州统计局", "type": 2 },
    { "id": 3490, "pid": 297, "name": "阿坝州国资委", "type": 2 },
    { "id": 3491, "pid": 297, "name": "阿坝州扶贫开发局", "type": 2 },
    { "id": 3492, "pid": 297, "name": "阿坝州市场监管局", "type": 2 },
    { "id": 3493, "pid": 297, "name": "阿坝州广播电视局", "type": 2 },
    { "id": 3494, "pid": 297, "name": "阿坝州医疗保障局", "type": 2 },
    { "id": 3495, "pid": 297, "name": "阿坝州档案馆", "type": 2 },
    { "id": 3496, "pid": 297, "name": "阿坝州行政审批局", "type": 2 },
    { "id": 3497, "pid": 297, "name": "阿坝州防震减灾局", "type": 2 },
    { "id": 3498, "pid": 297, "name": "阿坝州藏文编译局", "type": 2 },
    { "id": 3499, "pid": 297, "name": "阿坝州志办", "type": 2 },
    { "id": 3500, "pid": 297, "name": "阿坝州供销社", "type": 2 },
    { "id": 3501, "pid": 297, "name": "阿坝州工业园区", "type": 2 },
    { "id": 3502, "pid": 297, "name": "阿坝州公积金中心", "type": 2 },
    { "id": 3503, "pid": 297, "name": "阿坝州公共资源交易中心", "type": 2 },
    { "id": 3504, "pid": 297, "name": "阿坝行政审批服务中心", "type": 2 },
    { "id": 3505, "pid": 297, "name": "阿坝州政务中心", "type": 2 },
    { "id": 3506, "pid": 297, "name": "阿坝州公务服务中心", "type": 2 },
    { "id": 3507, "pid": 297, "name": "阿坝州总工会", "type": 2 },
    { "id": 3508, "pid": 297, "name": "阿坝团州委", "type": 2 },
    { "id": 3509, "pid": 297, "name": "阿坝州妇联", "type": 2 },
    { "id": 3510, "pid": 297, "name": "阿坝州科协", "type": 2 },
    { "id": 3511, "pid": 297, "name": "阿坝州工商联", "type": 2 },
    { "id": 3512, "pid": 297, "name": "阿坝州残联", "type": 2 },
    { "id": 3513, "pid": 297, "name": "阿坝州文联", "type": 2 },
    { "id": 3514, "pid": 297, "name": "阿坝州红十字会", "type": 2 },
    { "id": 3515, "pid": 297, "name": "阿坝州社科联", "type": 2 },
    { "id": 3516, "pid": 297, "name": "阿坝日报社", "type": 2 },
    { "id": 3517, "pid": 297, "name": "阿坝州广播电视台", "type": 2 },
    { "id": 3518, "pid": 297, "name": "阿坝州公路局", "type": 2 },
    { "id": 3519, "pid": 297, "name": "阿坝州医院", "type": 2 },
    { "id": 3520, "pid": 297, "name": "阿坝藏医院", "type": 2 },
    { "id": 3521, "pid": 297, "name": "阿坝州疾控中心", "type": 2 },
    { "id": 3522, "pid": 297, "name": "阿坝州国安局", "type": 2 },
    { "id": 3523, "pid": 297, "name": "阿坝州税务局", "type": 2 },
    { "id": 3524, "pid": 297, "name": "阿坝州气象局", "type": 2 },
    { "id": 3525, "pid": 297, "name": "阿坝州邮政管理局", "type": 2 },
    { "id": 3526, "pid": 297, "name": "阿坝州统计调查队", "type": 2 },
    { "id": 3527, "pid": 297, "name": "阿坝州水文资源勘测局", "type": 2 },
    { "id": 3528, "pid": 297, "name": "马师校", "type": 2 },
    { "id": 3529, "pid": 297, "name": "阿坝马尔康中学", "type": 2 },
    { "id": 3530, "pid": 297, "name": "阿坝州卫校", "type": 2 },
    { "id": 3531, "pid": 297, "name": "阿坝州文旅公司", "type": 2 },
    { "id": 3532, "pid": 297, "name": "阿坝大九旅集团公司", "type": 2 },
    { "id": 3533, "pid": 297, "name": "阿坝州烟草公司", "type": 2 },
    { "id": 3534, "pid": 297, "name": "阿坝州国投公司", "type": 2 },
    { "id": 3535, "pid": 297, "name": "阿坝红原机场", "type": 2 },
    { "id": 3536, "pid": 297, "name": "阿坝铁塔公司", "type": 2 },
    { "id": 3537, "pid": 297, "name": "阿坝州电信公司", "type": 2 },
    { "id": 3538, "pid": 297, "name": "阿坝州移动公司", "type": 2 },
    { "id": 3539, "pid": 297, "name": "阿坝州联通公司", "type": 2 },
    { "id": 3540, "pid": 297, "name": "阿坝州邮政公司", "type": 2 },
    { "id": 3541, "pid": 297, "name": "马尔康干休所", "type": 2 },
    { "id": 3542, "pid": 297, "name": "（阿坝）成都干休所", "type": 2 },
    { "id": 3543, "pid": 297, "name": "（阿坝）都江堰干休所", "type": 2 },
    { "id": 3544, "pid": 297, "name": "（阿坝）郫都区干休所", "type": 2 },
    { "id": 3545, "pid": 297, "name": "阿坝州退管中心", "type": 2 },
    { "id": 3546, "pid": 297, "name": "阿坝州环境监测中心站", "type": 2 },
    { "id": 3547, "pid": 297, "name": "阿坝州农投公司", "type": 2 },
    { "id": 3548, "pid": 297, "name": "其他", "type": 2 },
    { "id": 3549, "pid": 298, "name": "甘孜州纪委监委", "type": 2 },
    { "id": 3550, "pid": 298, "name": "甘孜州委办公室", "type": 2 },
    { "id": 3551, "pid": 298, "name": "甘孜州委组织部", "type": 2 },
    { "id": 3552, "pid": 298, "name": "甘孜州委宣传部", "type": 2 },
    { "id": 3553, "pid": 298, "name": "甘孜州委统战部", "type": 2 },
    { "id": 3554, "pid": 298, "name": "甘孜州人大办公室", "type": 2 },
    { "id": 3555, "pid": 298, "name": "甘孜州政府办公室", "type": 2 },
    { "id": 3556, "pid": 298, "name": "甘孜州政协办公室", "type": 2 },
    { "id": 3557, "pid": 298, "name": "甘孜州法院", "type": 2 },
    { "id": 3558, "pid": 298, "name": "甘孜州检察院", "type": 2 },
    { "id": 3559, "pid": 298, "name": "甘孜州发改委", "type": 2 },
    { "id": 3560, "pid": 298, "name": "甘孜州经信局", "type": 2 },
    { "id": 3561, "pid": 298, "name": "甘孜州公安局", "type": 2 },
    { "id": 3562, "pid": 298, "name": "甘孜州民政局", "type": 2 },
    { "id": 3563, "pid": 298, "name": "甘孜州司法局", "type": 2 },
    { "id": 3564, "pid": 298, "name": "甘孜州财政局", "type": 2 },
    { "id": 3565, "pid": 298, "name": "甘孜州人社局", "type": 2 },
    { "id": 3566, "pid": 298, "name": "甘孜州自然资源局", "type": 2 },
    { "id": 3567, "pid": 298, "name": "甘孜州生态环境局", "type": 2 },
    { "id": 3568, "pid": 298, "name": "甘孜州水利局", "type": 2 },
    { "id": 3569, "pid": 298, "name": "甘孜州商务局", "type": 2 },
    { "id": 3570, "pid": 298, "name": "甘孜州应急管理局", "type": 2 },
    { "id": 3571, "pid": 298, "name": "甘孜日报社", "type": 2 },
    { "id": 3572, "pid": 298, "name": "甘孜州住建局", "type": 2 },
    { "id": 3573, "pid": 298, "name": "甘孜州农牧农村局", "type": 2 },
    { "id": 3574, "pid": 298, "name": "甘孜州文广旅局", "type": 2 },
    { "id": 3575, "pid": 298, "name": "甘孜州市场监管局", "type": 2 },
    { "id": 3576, "pid": 298, "name": "甘孜州公路局", "type": 2 },
    { "id": 3577, "pid": 298, "name": "甘孜州烟草专卖局", "type": 2 },
    { "id": 3578, "pid": 298, "name": "甘孜州交通局", "type": 2 },
    { "id": 3579, "pid": 298, "name": "甘孜州林草局", "type": 2 },
    { "id": 3580, "pid": 298, "name": "甘孜州审计局", "type": 2 },
    { "id": 3581, "pid": 298, "name": "亚青寺管委会", "type": 2 },
    { "id": 3582, "pid": 298, "name": "甘孜州税务局", "type": 2 },
    { "id": 3583, "pid": 298, "name": "甘孜州气象局", "type": 2 },
    { "id": 3584, "pid": 298, "name": "甘孜州委党校", "type": 2 },
    { "id": 3585, "pid": 298, "name": "喇荣寺管委会", "type": 2 },
    { "id": 3586, "pid": 298, "name": "甘孜州国安办", "type": 2 },
    { "id": 3587, "pid": 298, "name": "甘孜州统计局", "type": 2 },
    { "id": 3588, "pid": 298, "name": "甘孜州医疗保障局", "type": 2 },
    { "id": 3589, "pid": 298, "name": "甘孜州民干校", "type": 2 },
    { "id": 3590, "pid": 298, "name": "色达五明佛学院", "type": 2 },
    { "id": 3591, "pid": 298, "name": "甘孜州国资委", "type": 2 },
    { "id": 3592, "pid": 298, "name": "甘孜州扶贫开发局", "type": 2 },
    { "id": 3593, "pid": 298, "name": "甘孜州综合执法局", "type": 2 },
    { "id": 3594, "pid": 298, "name": "甘孜州行政审批局", "type": 2 },
    { "id": 3595, "pid": 298, "name": "甘孜州委老干局", "type": 2 },
    { "id": 3596, "pid": 298, "name": "甘孜州科技局", "type": 2 },
    { "id": 3597, "pid": 298, "name": "甘孜州机关事务局", "type": 2 },
    { "id": 3598, "pid": 298, "name": "甘孜州团州委", "type": 2 },
    { "id": 3599, "pid": 298, "name": "甘孜州总工会", "type": 2 },
    { "id": 3600, "pid": 298, "name": "甘孜州妇联", "type": 2 },
    { "id": 3601, "pid": 298, "name": "甘孜州科协", "type": 2 },
    { "id": 3602, "pid": 298, "name": "甘孜州工商联", "type": 2 },
    { "id": 3603, "pid": 298, "name": "甘孜州残联", "type": 2 },
    { "id": 3604, "pid": 298, "name": "甘孜州佛协", "type": 2 },
    { "id": 3605, "pid": 298, "name": "甘孜州红十字会", "type": 2 },
    { "id": 3606, "pid": 298, "name": "甘孜州党史研究室", "type": 2 },
    { "id": 3607, "pid": 298, "name": "甘孜州档案馆", "type": 2 },
    { "id": 3608, "pid": 298, "name": "甘孜州地方志办", "type": 2 },
    { "id": 3609, "pid": 298, "name": "甘孜州邮政管理局", "type": 2 },
    { "id": 3610, "pid": 298, "name": "甘孜州直工委", "type": 2 },
    { "id": 3611, "pid": 298, "name": "甘孜州退役军人事务", "type": 2 },
    { "id": 3612, "pid": 298, "name": "甘孜州国调队", "type": 2 },
    { "id": 3613, "pid": 298, "name": "甘孜州水文局", "type": 2 },
    { "id": 3614, "pid": 298, "name": "甘孜州群工局", "type": 2 },
    { "id": 3615, "pid": 298, "name": "甘孜州住房公局", "type": 2 },
    { "id": 3616, "pid": 298, "name": "康定地震中心", "type": 2 },
    { "id": 3617, "pid": 298, "name": "甘孜州委政法委", "type": 2 },
    { "id": 3618, "pid": 298, "name": "甘孜州委编办", "type": 2 },
    { "id": 3619, "pid": 298, "name": "甘孜州积金管理中心", "type": 2 },
    { "id": 3620, "pid": 298, "name": "其他", "type": 2 },
    { "id": 3621, "pid": 299, "name": "凉山州纪委监委", "type": 2 },
    { "id": 3622, "pid": 299, "name": "凉山州法院", "type": 2 },
    { "id": 3623, "pid": 299, "name": "凉山州检察院", "type": 2 },
    { "id": 3624, "pid": 299, "name": "凉山州委办", "type": 2 },
    { "id": 3625, "pid": 299, "name": "凉山州人大常委会办", "type": 2 },
    { "id": 3626, "pid": 299, "name": "凉山州政府办", "type": 2 },
    { "id": 3627, "pid": 299, "name": "凉山州政协办", "type": 2 },
    { "id": 3628, "pid": 299, "name": "凉山州委组织部", "type": 2 },
    { "id": 3629, "pid": 299, "name": "凉山州委宣传部", "type": 2 },
    { "id": 3630, "pid": 299, "name": "凉山州委统战部", "type": 2 },
    { "id": 3631, "pid": 299, "name": "凉山州委政法委", "type": 2 },
    { "id": 3632, "pid": 299, "name": "凉山州委政研室", "type": 2 },
    { "id": 3633, "pid": 299, "name": "凉山州委编办", "type": 2 },
    { "id": 3634, "pid": 299, "name": "凉山州直机关工委", "type": 2 },
    { "id": 3635, "pid": 299, "name": "凉山州委老干部局", "type": 2 },
    { "id": 3636, "pid": 299, "name": "凉山州委保密机要局", "type": 2 },
    { "id": 3637, "pid": 299, "name": "凉山州委目标绩效管理办", "type": 2 },
    { "id": 3638, "pid": 299, "name": "凉山州委党校", "type": 2 },
    { "id": 3639, "pid": 299, "name": "凉山日报社", "type": 2 },
    { "id": 3640, "pid": 299, "name": "凉山州发展改革委", "type": 2 },
    { "id": 3641, "pid": 299, "name": "凉山州经济和信息化局", "type": 2 },
    { "id": 3642, "pid": 299, "name": "凉山州教育体育局", "type": 2 },
    { "id": 3643, "pid": 299, "name": "凉山州科技局", "type": 2 },
    { "id": 3644, "pid": 299, "name": "凉山州民族宗教委", "type": 2 },
    { "id": 3645, "pid": 299, "name": "凉山州公安局", "type": 2 },
    { "id": 3646, "pid": 299, "name": "凉山州民政局", "type": 2 },
    { "id": 3647, "pid": 299, "name": "凉山州司法局", "type": 2 },
    { "id": 3648, "pid": 299, "name": "凉山州财政局", "type": 2 },
    { "id": 3649, "pid": 299, "name": "凉山州人力资源社会保障局", "type": 2 },
    { "id": 3650, "pid": 299, "name": "凉山州自然资源局", "type": 2 },
    { "id": 3651, "pid": 299, "name": "凉山州生态环境局", "type": 2 },
    { "id": 3652, "pid": 299, "name": "凉山州住房城乡建设局", "type": 2 },
    { "id": 3653, "pid": 299, "name": "凉山州交通运输局", "type": 2 },
    { "id": 3654, "pid": 299, "name": "凉山州水利局", "type": 2 },
    { "id": 3655, "pid": 299, "name": "凉山州农业农村局", "type": 2 },
    { "id": 3656, "pid": 299, "name": "凉山州商务局", "type": 2 },
    { "id": 3657, "pid": 299, "name": "凉山州文化广电和旅游局", "type": 2 },
    { "id": 3658, "pid": 299, "name": "凉山州卫生健康委", "type": 2 },
    { "id": 3659, "pid": 299, "name": "凉山州退役军人事务局", "type": 2 },
    { "id": 3660, "pid": 299, "name": "凉山州应急管理局", "type": 2 },
    { "id": 3661, "pid": 299, "name": "凉山州审计局", "type": 2 },
    { "id": 3662, "pid": 299, "name": "凉山州国资委", "type": 2 },
    { "id": 3663, "pid": 299, "name": "凉山州市场监管局", "type": 2 },
    { "id": 3664, "pid": 299, "name": "凉山州统计局", "type": 2 },
    { "id": 3665, "pid": 299, "name": "凉山州机关事务管理局", "type": 2 },
    { "id": 3666, "pid": 299, "name": "凉山州扶贫开发局", "type": 2 },
    { "id": 3667, "pid": 299, "name": "凉山州信访局", "type": 2 },
    { "id": 3668, "pid": 299, "name": "凉山州金融工作局", "type": 2 },
    { "id": 3669, "pid": 299, "name": "凉山州经济合作和外事局", "type": 2 },
    { "id": 3670, "pid": 299, "name": "凉山州林业和草原局", "type": 2 },
    { "id": 3671, "pid": 299, "name": "凉山州医疗保障局", "type": 2 },
    { "id": 3672, "pid": 299, "name": "凉山州政务服务管理局", "type": 2 },
    { "id": 3673, "pid": 299, "name": "凉山州人防办", "type": 2 },
    { "id": 3674, "pid": 299, "name": "凉山州档案馆", "type": 2 },
    { "id": 3675, "pid": 299, "name": "凉山州防震减灾局", "type": 2 },
    { "id": 3676, "pid": 299, "name": "凉山州史志办", "type": 2 },
    { "id": 3677, "pid": 299, "name": "凉山州供销社", "type": 2 },
    { "id": 3678, "pid": 299, "name": "凉山州语言文字服务中心", "type": 2 },
    { "id": 3679, "pid": 299, "name": "凉山州住房公积金管理中心", "type": 2 },
    { "id": 3680, "pid": 299, "name": "凉山州绿色家园管委会", "type": 2 },
    { "id": 3681, "pid": 299, "name": "凉山州总工会", "type": 2 },
    { "id": 3682, "pid": 299, "name": "凉山团州委", "type": 2 },
    { "id": 3683, "pid": 299, "name": "凉山州妇联", "type": 2 },
    { "id": 3684, "pid": 299, "name": "凉山州科协", "type": 2 },
    { "id": 3685, "pid": 299, "name": "凉山州文联", "type": 2 },
    { "id": 3686, "pid": 299, "name": "凉山州残联", "type": 2 },
    { "id": 3687, "pid": 299, "name": "凉山州国安局", "type": 2 },
    { "id": 3688, "pid": 299, "name": "国家统计局凉山调查队", "type": 2 },
    { "id": 3689, "pid": 299, "name": "凉山州税务局", "type": 2 },
    { "id": 3690, "pid": 299, "name": "凉山州气象局", "type": 2 },
    { "id": 3691, "pid": 299, "name": "凉山州监狱管理局", "type": 2 },
    { "id": 3692, "pid": 299, "name": "凉山州邮政管理局", "type": 2 },
    { "id": 3693, "pid": 299, "name": "西昌地震中心站", "type": 2 },
    { "id": 3694, "pid": 299, "name": "凉山州烟草专卖局（公司）", "type": 2 },
    { "id": 3695, "pid": 299, "name": "凉山州农科所", "type": 2 },
    { "id": 3696, "pid": 299, "name": "凉山州民干校", "type": 2 },
    { "id": 3697, "pid": 299, "name": "凉山州一医院", "type": 2 },
    { "id": 3698, "pid": 299, "name": "凉山州二医院", "type": 2 },
    { "id": 3699, "pid": 299, "name": "凉山州中西医结合医院", "type": 2 },
    { "id": 3700, "pid": 299, "name": "凉山州疾控中心", "type": 2 },
    { "id": 3701, "pid": 299, "name": "凉山州广播电视台", "type": 2 },
    { "id": 3702, "pid": 299, "name": "省广电网络凉山分公司", "type": 2 },
    { "id": 3703, "pid": 299, "name": "省广电505台", "type": 2 },
    { "id": 3704, "pid": 299, "name": "省广电608台", "type": 2 },
    { "id": 3705, "pid": 299, "name": "其他", "type": 2 },
    { "id": 3706, "pid": 288, "name": "乐山市教育局", "type": 2 },
    { "id": 3707, "pid": 288, "name": "乐山市国资委", "type": 2 },
    { "id": 3621, "pid": 298, "name": "甘孜州卫健委", "type": 2 },
    { "id": 3706, "pid": 299, "name": "凉山州卫健委", "type": 2 },
    { "id": 136, "pid": 1, "name": "国网四川省电力公司", "type": 1 },
    { "id": 137, "pid": 1, "name": "中国铁路成都局集团有限公司", "type": 1 },

]

export function getAreaMap() {
    let map = {};
    areas.forEach(item => {
        map[item.id] = item;
    });
    return map
}

export function getAreaTree() {
    let data = areas.map(item => {
        return {
            "value": item.id,
            "text": item.name,
            "pid": item.pid,
            "id": item.id,
            "type": item.type
        }
    })
    let result = []
    if (!Array.isArray(data)) {
        return result
    }
    data.forEach(item => {
        delete item.children;
    });
    let map = {};
    data.forEach(item => {
        map[item.id] = item;
    });
    data.forEach(item => {
        let parent = map[item.pid];
        if (parent) {
            (parent.children || (parent.children = [])).push(item);
        } else {
            result.push(item);
        }
    });
    return result;
}